<template>
  <div class="main-view-padding has-header">
    <div class="header main" v-header-position-lock>
      <div class="align-left"></div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons"/>
      </div>
      <div class="align-right">
        <headerbuttonstack v-if="stage===1" :state="sideButtons" />
      </div>
    </div>
    <div v-if="stage === 1"
      style="
        font-size: 32px;
        text-align: left;
        color: #e51550;
        border-bottom: 1px solid #ccc;
        padding: 5px;
        font-weight: 400;
        margin-bottom: 25px;
      "
    >
        {{ $t('settings.sync.employeeSyncSettings') }}
    </div>
    <div v-if="stage === 2"
      style="
        font-size: 32px;
        text-align: left;
        color: #e51550;
        border-bottom: 1px solid #ccc;
        padding: 5px;
        font-weight: 400;
        margin-bottom: 25px;
      "
    >
        {{ $t('settings.sync.exportOverview') }}
    </div>

    <div v-if="loading">
        <i class="fas fa-circle-notch fa-spin"></i>
        {{ $t('settings.sync.title') }}<br/>
        {{ $t('settings.sync.description') }}<br/>
        <div style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"></div>
    </div>

    <div v-if="!loading && !employeeSyncSetting">
        <strong>{{ $t('settings.sync.notSupported') }}</strong>
      <div
        style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"
      ></div>
    </div>

    <div v-if="!loading && !hasAccessRights && employeeSyncSetting">
        <strong>{{ $t('settings.sync.noAccess.title') }}</strong>
      <br/>
        {{ $t('settings.sync.noAccess.description') }}
      <br style="clear: both"/>
      <div
        style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"
      ></div>
    </div>

    <div v-if="!loading && hasAccessRights && otherError && employeeSyncSetting">
        <strong>{{ $t('settings.sync.otherError.title') }}</strong>
        <br/>
        {{ $t('settings.sync.otherError.tryReload') }}<br/>
        <br/>
        {{ $t('settings.sync.otherError.contactSupport') }}<br/>
        <small class="text-muted">&lt; {{ otherErrorMessage }} &gt;</small>
      <br style="clear: both"/>
      <div
        style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"
      ></div>
    </div>

    <div v-if="!loading && hasAccessRights && !otherError && companyData == null && employeeSyncSetting">
        {{ $t('settings.sync.companyDataNotLoaded') }}
      <br style="clear: both"/>

      <div
        style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"
      ></div>
    </div>

    <div class="parentBox" v-if="!loading && hasAccessRights && !otherError && companyData != null && employeeSyncSetting && stage === 1">

      <!-- Einstellungen -->
      <div class="xColumn2">
        <div class="header">{{ $t('global.ui.settings') }}</div>

        <!-- internal id -->
        <div class="entryBox">
            <div class="entryHeader">{{ $t('settings.sync.companyMlId') }}</div>
          <div class="entryData">
            {{ internalId }}
          </div>
        </div>

        <!-- company external id -->
        <div
          v-if="companyData.softwareId === 0 && employeeSyncSetting.externalId"
          class="entryBox"
        >
            <div class="entryHeader">{{ $t('settings.sync.companyBmdId') }}</div>
          <div v-if="saves || !editieren" class="entryData">
            {{ bmdId }}
          </div>
          <div v-if="!saves && editieren" class="entryData">
            <input v-model="inputBmdId" style="width: 98%"/>
          </div>
        </div>
        <div
          v-if="companyData.softwareId === 1 && employeeSyncSetting.externalId"
          class="entryBox"
        >
            <div class="entryHeader">{{ $t('settings.sync.companyDpwId') }}</div>
          <div v-if="saves || !editieren" class="entryData">
            {{ dpwId }}
          </div>
          <div v-if="!saves && editieren" class="entryData">
            <input v-model="inputDpwId" style="width: 98%"/>
          </div>
        </div>
        <div
          v-if="![0,1].includes(companyData.softwareId) && employeeSyncSetting.externalId"
          class="entryBox"
        >
            <div class="entryHeader">{{ $t('settings.sync.companyExternalId') }}</div>
          <div v-if="saves || !editieren" class="entryData">
            {{ companyNumber }}
          </div>
          <div v-if="!saves && editieren" class="entryData">
            <input v-model="inputCompanyNumber" style="width: 98%"/>
          </div>
        </div>

        <!-- taxOfficeSerialNumber -->
        <div v-if="employeeSyncSetting.taxOfficeSerialNumber" class="entryBox">
            <div class="entryHeader">{{ $t('settings.sync.taxOfficeNumber') }}</div>
          <div v-if="saves || !editieren" class="entryData">
            {{ employeeSyncSettingsData.taxOfficeSerialNumber }}
          </div>
          <div v-if="!saves && editieren" class="entryData">
            <input v-model="employeeSyncSettingsData_input.taxOfficeSerialNumber" style="width: 98%"/>
          </div>
        </div>

        <!-- Import Einstellungen -->
          <div class="sub-header">{{ $t('settings.sync.importSettings') }}</div>

        <!-- change mode -->
        <div v-if="employeeSyncSetting.employeeChangeMode" class="entryBox">
            <div class="entryHeader">
                {{ externalSoftwaresMap[companyData.softwareId] ? externalSoftwaresMap[companyData.softwareId].name : "Externe" }}
                {{ $t('settings.sync.employeeDataChangeMode') }}
            </div>
            <div v-if="saves || !editieren" class="entryData">
            <span v-if="true">{{ enumEmployeeChangedFromBMDModes[employeeSyncSettingsData.employeeChangeMode] }}</span>
          </div>
          <div v-if="!saves && editieren" class="entryData">
            <select class="modern-select" v-model="employeeSyncSettingsData_input.employeeChangeMode" style="width: 98%">
              <option
                v-for="(entry, key) in enumEmployeeChangedFromBMDModes"
                :value="key"
                :key="key"
              >
                {{ entry }}
              </option>
            </select>
          </div>
        </div>

        <!-- auto create -->
        <div v-if="employeeSyncSetting.employeeAutoCreate" class="entryBox">
            <div class="entryHeader">
                {{ $t('settings.sync.createNewEmployeesAutomatically', {
                software: externalSoftwaresMap[companyData.softwareId]
                    ? externalSoftwaresMap[companyData.softwareId].name
                    : "Externe"
            }) }}
            </div>
            <div v-if="saves || !editieren" class="entryData">
            <i class="fas fa-check-circle checkbox disabled"
               v-bind:class="{ false: !employeeSyncSettingsData.employeeAutoCreate }"></i>
          </div>
          <div v-if="!saves && editieren" class="entryData">
            <i class="fas fa-check-circle checkbox" :key="'cb-eac'"
               v-bind:class="{ false: !employeeSyncSettingsData_input.employeeAutoCreate }"
               v-on:click="employeeSyncSettingsData_input.employeeAutoCreate = !employeeSyncSettingsData_input.employeeAutoCreate"></i>
          </div>
        </div>

        <!-- auto create -->
        <div v-if="employeeSyncSetting.costCenterAutoCreate" class="entryBox">
            {{ $t('settings.sync.autoCreateUnknownCostCenters') }}
          <div v-if="saves || !editieren" class="entryData">
            <i class="fas fa-check-circle checkbox disabled"
               v-bind:class="{ false: !employeeSyncSettingsData.costCenterAutoCreate }"></i>
          </div>
          <div v-if="!saves && editieren" class="entryData">
            <i class="fas fa-check-circle checkbox" :key="'cb-eac'"
               v-bind:class="{ false: !employeeSyncSettingsData_input.costCenterAutoCreate }"
               v-on:click="employeeSyncSettingsData_input.costCenterAutoCreate = !employeeSyncSettingsData_input.costCenterAutoCreate"></i>
          </div>
        </div>


        <!-- Export Einstellungen -->
          {{ $t('settings.sync.exportSettings') }}

        <div class="card">
          <div class="tabs">
            <div v-if="!editieren">
              <button v-for="profile in exportProfiles" :key="profile.id" class="tab" v-bind:class="{active: selectedProfileId === profile.id}" v-on:click="selectedProfileId = profile.id">
                {{ profile.label }}
              </button>
            </div>
            <div v-else>
              <button v-for="profile in exportProfiles_input" :key="profile.id" class="tab" v-bind:class="{active: selectedProfileId === profile.id}" v-on:click="selectedProfileId = profile.id">
                {{ profile.label }}
              </button>
            </div>
            <!-- add new profile button (simple) -->
            <div style="margin-left:auto; display:flex; align-items:center; gap:8px;">
              <button v-on:click="openAddNewExportProfilePopup()" :title="$t('settings.sync.createNewProfile')" style="background:transparent;border:0;color:var(--contrast-4);cursor:pointer;font-weight:600;">
                <i class="fas fa-plus"></i>
              </button>
              <button
                v-if="(exportProfiles.find(profile => selectedProfileId === profile.id) && !exportProfiles.find(profile => selectedProfileId === profile.id).isDefault) || selectedProfileId < 0"
                v-on:click="deleteCurrentProfile(selectedProfileId)" :title="$t('settings.sync.deleteProfile')" style="background:transparent;border:0;color:var(--contrast-4);cursor:pointer;font-weight:600;">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>

          <!-- pdf payslipPassword -->
          <div v-if="employeeSyncSetting.payslipPassword" class="entryBox">
              <div class="entryHeader">
                  {{ $t('settings.sync.payrollPdfPassword') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">
              {{ getPayslipPasswordSettingByKey(selectedProfile.payslipPassword) }}
            </div>
            <div v-if="!saves && editieren" class="entryData">
              <select class="modern-select" v-model="selectedProfileInput.payslipPassword" style="width: 98%">
                <option v-for="item in payslipPasswordSettings" :value="item.value" :key="item.value">
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>

          <!-- exportLastNameBlockLetters -->
          <div v-if="employeeSyncSetting.exportLastNameBlockLetters" class="entryBox">
              <div class="entryHeader">
                  {{ $t('settings.sync.exportLastnameUppercase') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">
              <i class="fas fa-check-circle checkbox disabled"
                v-bind:class="{ false: !selectedProfile.exportLastNameBlockLetters }"></i>
            </div>
            <div v-if="!saves && editieren" class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-elnbl'"
                v-bind:class="{ false: !selectedProfileInput.exportLastNameBlockLetters }"
                v-on:click="selectedProfileInput.exportLastNameBlockLetters = !selectedProfileInput.exportLastNameBlockLetters"></i>
            </div>
          </div>

          <!-- exportLatestContractOnly -->
          <div v-if="employeeSyncSetting.exportLatestContractOnly" class="entryBox">
              <div class="entryHeader">
                  {{ $t('settings.sync.exportOnlyLatestContract') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">
              <i class="fas fa-check-circle checkbox disabled"
                v-bind:class="{ false: !selectedProfile.exportLatestContractOnly }"></i>
            </div>
            <div v-if="!saves && editieren" class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-elco'"
                v-bind:class="{ false: !selectedProfileInput.exportLatestContractOnly }"
                v-on:click="selectedProfileInput.exportLatestContractOnly = !selectedProfileInput.exportLatestContractOnly"></i>
            </div>
          </div>

          <!-- ignoreExternalEmployees -->
          <div v-if="employeeSyncSetting.ignoreExternalEmployees" class="entryBox">
              <div class="entryHeader">
                  {{ $t('settings.sync.exportExternalEmployees') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">
              <i class="fas fa-check-circle checkbox disabled"
                v-bind:class="{ false: selectedProfile.ignoreExternalEmployees }"></i>
            </div>
            <div v-if="!saves && editieren" class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-iee'"
                v-bind:class="{ false: selectedProfileInput.ignoreExternalEmployees }"
                v-on:click="selectedProfileInput.ignoreExternalEmployees = !selectedProfileInput.ignoreExternalEmployees"></i>
            </div>
          </div>

          <!-- ignoreHiddenEmployees -->
          <div v-if="employeeSyncSetting.ignoreHiddenEmployees" class="entryBox">
              <div class="entryHeader">
                  {{ $t('settings.sync.exportHiddenEmployees') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">
              <i class="fas fa-check-circle checkbox disabled"
                v-bind:class="{ false: selectedProfile.ignoreHiddenEmployees }"></i>
            </div>
            <div v-if="!saves && editieren" class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-ihe'"
                v-bind:class="{ false: selectedProfileInput.ignoreHiddenEmployees }"
                v-on:click="selectedProfileInput.ignoreHiddenEmployees = !selectedProfileInput.ignoreHiddenEmployees"></i>
            </div>
          </div>

          <!-- ignoreInactiveEmployees -->
          <div v-if="employeeSyncSetting.ignoreInactiveEmployees" class="entryBox">
              <div class="entryHeader">
                  {{ $t('settings.sync.exportInactiveEmployees') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">
              <i class="fas fa-check-circle checkbox disabled"
                v-bind:class="{ false: selectedProfile.ignoreInactiveEmployees }"></i>
            </div>
            <div v-if="!saves && editieren" class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-iie'"
                v-bind:class="{ false: selectedProfileInput.ignoreInactiveEmployees }"
                v-on:click="selectedProfileInput.ignoreInactiveEmployees = !selectedProfileInput.ignoreInactiveEmployees"></i>
            </div>
          </div>

          <!-- exportUnchangedEmployees -->
          <div v-if="employeeSyncSetting.exportUnchangedEmployees" class="entryBox">
              <div class="entryHeader">
                  {{ $t('settings.sync.exportUnchangedEmployees') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">
              <i class="fas fa-check-circle checkbox disabled"
                v-bind:class="{ false: !selectedProfile.exportUnchangedEmployees }"></i>
            </div>
            <div v-if="!saves && editieren" class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-eceo'"
                v-bind:class="{ false: !selectedProfileInput.exportUnchangedEmployees }"
                v-on:click="selectedProfileInput.exportUnchangedEmployees = !selectedProfileInput.exportUnchangedEmployees"></i>
            </div>
          </div>

          <!-- exportChangedEmployees -->
          <div v-if="employeeSyncSetting.exportChangedEmployees" class="entryBox">
              <div class="entryHeader">
                  {{ $t('settings.sync.exportChangedEmployees') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">
              <i class="fas fa-check-circle checkbox disabled"
                v-bind:class="{ false: !selectedProfile.exportChangedEmployees }"></i>
            </div>
            <div v-if="!saves && editieren" class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-eceo'"
                v-bind:class="{ false: !selectedProfileInput.exportChangedEmployees }"
                v-on:click="selectedProfileInput.exportChangedEmployees = !selectedProfileInput.exportChangedEmployees"></i>
            </div>
          </div>

          <!-- exportNewEmployees -->
          <div v-if="employeeSyncSetting.exportNewEmployees" class="entryBox">
              <div class="entryHeader">
                  {{ $t('settings.sync.exportNewEmployees') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">
              <i class="fas fa-check-circle checkbox disabled"
                v-bind:class="{ false: !selectedProfile.exportNewEmployees }"></i>
            </div>
            <div v-if="!saves && editieren" class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-eceo'"
                v-bind:class="{ false: !selectedProfileInput.exportNewEmployees }"
                v-on:click="selectedProfileInput.exportNewEmployees = !selectedProfileInput.exportNewEmployees"></i>
            </div>
          </div>

        </div> <!-- end card -->


        <!-- Auto Export Einstellungen -->
          <div class="sub-header">
              {{ $t('settings.sync.automaticExports') }}
          </div>

              <!-- enableExportViaTransferService -->
        <div v-if="employeeSyncSetting.enableExportViaTransferService" class="entryBox">
          <div class="entryHeader">
              {{ $t('settings.sync.enableAutomaticExports') }}
          </div>
          <div v-if="saves || !editieren" class="entryData">
            <i class="fas fa-check-circle checkbox disabled"
               v-bind:class="{ false: !employeeSyncSettingsData.enableExportViaTransferService }"></i>
          </div>
          <div v-if="!saves && editieren" class="entryData">
            <i class="fas fa-check-circle checkbox" :key="'cb-eevts'"
               v-bind:class="{ false: !employeeSyncSettingsData_input.enableExportViaTransferService }"
               v-on:click="employeeSyncSettingsData_input.enableExportViaTransferService = !employeeSyncSettingsData_input.enableExportViaTransferService"></i>
          </div>
        </div>

        <!-- enablePeriodicExport -->
        <div v-if="employeeSyncSetting.enablePeriodicExport" class="entryBox">
            <div class="entryHeader">
                {{ $t('settings.sync.enablePeriodicExport') }}
            </div>
            <div v-if="saves || !editieren" class="entryData">
            <i class="fas fa-check-circle checkbox disabled"
               v-bind:class="{ false: !employeeSyncSettingsData.enablePeriodicExport }"></i>
          </div>
          <div v-if="!saves && editieren" class="entryData" style="display:flex; justify-content:space-between">
            <i class="fas fa-check-circle checkbox" :key="'cb-epe'"
               v-bind:class="{ false: !employeeSyncSettingsData_input.enablePeriodicExport }"
               v-on:click="employeeSyncSettingsData_input.enablePeriodicExport = !employeeSyncSettingsData_input.enablePeriodicExport"></i>
            <i v-if="employeeSyncSettingsData_input.enablePeriodicExport" class="fas fa-plus"  v-tooltip="$t('settings.sync.addTime')"
               v-on:click="periodicExportTimes_input.push({type: 0, dayOfMonth: 0, dayOfWeek: 0, hours: 0, minutes: 0})"></i>
          </div>
        </div>
        <!-- periodic export times -->
        <div v-if="(saves || !editieren) && employeeSyncSettingsData.enablePeriodicExport">
          <div v-for="time in periodicExportTimes" v-bind:key="time.id" class="entryBox">
            <div class="entryHeader" style="text-align: right; padding-right: 10px">
              {{ exportProfiles.find(e => e.id === time.exportProfileId).label }} -
              {{ periodicExportTimeTypes.find(e => e.value === time.type).label }}
            </div>
            <div class="entryData">{{ getPeriodicTimeLabel(time) }}</div>
          </div>
        </div>
        <div v-if="!saves && editieren && employeeSyncSettingsData_input.enablePeriodicExport">
          <div v-for="(time, index) in periodicExportTimes_input" :key="index" class="entryBox">
            <div class="entryHeader">
              <select class="modern-select" v-model="time.exportProfileId" style="width: 48%">
                <option v-for="profile in exportProfiles" :value="profile.id" :key="profile.id">
                  {{ profile.label }}
                </option>
              </select>
              &nbsp;
              <select class="modern-select" v-model="time.type" style="width: 48%">
                <option v-for="item in periodicExportTimeTypes" :value="item.value" :key="item.value">
                  {{ item.label }}
                </option>
              </select>
            </div>
            <div class="entryData">
              <select class="modern-select" v-if="time.type === 1" v-model="time.dayOfWeek" style="width: 150px">
                <option v-for="item in getPeriodicTimeTypeInputs(time.type)" :value="item.value" :key="item.value">
                  {{ item.label }}
                </option>
              </select>
              <select class="modern-select" v-if="time.type === 2" v-model="time.dayOfMonth" style="width: 150px">
                <option v-for="item in getPeriodicTimeTypeInputs(time.type)" :value="item.value" :key="item.value">
                  {{ item.label }}
                </option>
              </select>
              &nbsp;
              <input v-model="time.hours" type="number" style="width: 27px" />
              :
              <input v-model="time.minutes" type="number" style="width: 27px" />
              &nbsp;
              <i v-tooltip="$t('settings.sync.deleteTime')" class="fas fa-trash" v-on:click="deletePeriodicExportTime(index)" />
            </div>
          </div>
        </div>

      </div>

      <!-- contract WeekModelNr -->
      <div v-if="employeeSyncSetting.contractWeekModelNr" class="xColumn2">
        <div class="header" style="display: flex; justify-content: space-between">
            <div style="">
                {{ $t('settings.sync.weekModels') }}
            </div>
            <div style="width: fit-content; float: right">
            <i class="fas fa-check-circle checkbox" :key="'cb-hdc'"
               v-bind:class="{ false: !hideDeactivatedContracts, disabled: !saves && editieren }"
               v-on:click="hideDeactivatedContracts = !hideDeactivatedContracts"></i>
                <small class="text-secondary">&nbsp;{{ ' ' + $t('settings.sync.hideDisabledContracts') + ' '}}&nbsp;</small>
            <br>
            <i class="fas fa-check-circle checkbox" :key="'cb-csc'"
               v-bind:class="{ false: !combineSimilarContracts, disabled: !saves && editieren }"
               v-on:click="combineSimilarContracts = !combineSimilarContracts"></i>
                <small class="text-secondary">&nbsp;{{ ' ' + $t('settings.sync.combineSimilarContracts') + ' '}}&nbsp;</small>
          </div>
        </div>

        <div class="entryBox triple">
            <div v-if="combineSimilarContracts" class="entryHeader first">
                {{ $t('settings.sync.collectiveAgreement') }}
            </div>
            <div v-if="!combineSimilarContracts" class="entryHeader first">
                {{ $t('settings.sync.collectiveAgreementStoreId') }}
            </div>
            <div class="entryHeader">
                {{ $t('settings.sync.weekHoursAndDays') }}
            </div>
            <div class="entryHeader">
                {{ externalSoftwaresMap[companyData.softwareId]
                ? externalSoftwaresMap[companyData.softwareId].name
                : "Externes System" }}
                {{ $t('settings.sync.weekModelExternal') }}
            </div>
        </div>
        <div v-if="combineSimilarContracts">
          <div v-for="(collectiveContractArray, ccId) in similarAllowedContracts" v-bind:key="ccId">
            <template v-for="(weekWorkDaysArray, weekWorkDays) in collectiveContractArray">
              <div v-if="weekWorkDays !== 'ccId'" v-bind:key="weekWorkDays">
                <div class="entryBox triple" style="padding: 2px 7px" v-for="(weekTimeArray, weekTime) in weekWorkDaysArray" v-bind:key="weekWorkDays + '-' + weekTime">
                  <div class="entryHeaderLight first">{{ collectiveContractMap[ccId].name }}</div>
                    <div class="entryData">{{
                            $t('settings.sync.weekTimeSummary', {
                                hours: Math.round(((weekTime / 60.0) + Number.EPSILON) * 100) / 100,
                                days: weekWorkDays
                            })
                        }}
                    </div>
                  <div v-if="saves || !editieren" class="entryData">{{ similarContractWeekModelNrArray[ccId][weekWorkDays][weekTime] }}</div>
                  <div v-if="!saves && editieren" class="entryData"><input v-model="similarContractWeekModelNrArray_input[ccId][weekWorkDays][weekTime]"/></div>
                  <br style="clear: both"/>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div v-if="!combineSimilarContracts">
          <div v-for="storeAllowedContractArray in filteredAllowedContracts" v-bind:key="storeAllowedContractArray.id">
            <div class="entryBox triple" style="padding: 2px 7px" v-for="ac in storeAllowedContractArray" v-bind:key="ac.id">
              <div class="entryHeaderLight first">{{ ac.collectiveContractName + " (" + ac.storeId + ")" }}</div>
              <div class="entryData">
                <i v-tooltip="$t('settings.sync.details')"
                  v-on:click="selectedAllowedContract = ac; openAcDetailsModal()" class="fas fa-magnifying-glass"></i>
                  {{
                      $t('settings.sync.weekTimeSummary', {
                          hours: Math.round(((ac.weekTimeRegular / 60.0) + Number.EPSILON) * 100) / 100,
                          days: ac.weekWorkDaysRegular
                      })
                  }}
              </div>
              <div v-if="saves || !editieren" class="entryData">{{ ac.externalId }}</div>
              <div v-if="!saves && editieren" class="entryData"><input v-model="ac.externalId_input"/></div>
              <br style="clear: both"/>
            </div>
          </div>
        </div>
      </div>

      <!-- Kollektivverträge -->
      <div v-if="employeeSyncSetting.collectiveContracts" class="xColumn2">
          <div class="header">
              {{ $t('settings.sync.collectiveAgreements') }}
          </div>
          <div style="width: fit-content; float: right">
          <i class="fas fa-check-circle checkbox" :key="'cb-hucc'"
              v-bind:class="{ false: !hideUnusedCollectiveContracts, disabled: !saves && editieren }"
              v-on:click="hideUnusedCollectiveContracts = !hideUnusedCollectiveContracts"></i>
              <small class="text-secondary">
                  &nbsp;{{ $t('settings.sync.hideUnusedCollectiveAgreements') }}&nbsp;
              </small>
          </div>

        <div class="entryBox triple">
            <div class="entryHeader first">
                {{ $t('settings.sync.collectiveAgreement') }}
            </div>
            <div class="entryHeader">
                {{ externalSoftwaresMap[companyData.softwareId] ? externalSoftwaresMap[companyData.softwareId].name : "Externe" }} {{ $t('settings.sync.softwareIdEmployees') }}
            </div>
            <div class="entryHeader">
                {{ externalSoftwaresMap[companyData.softwareId] ? externalSoftwaresMap[companyData.softwareId].name : "Externe" }} {{ $t('settings.sync.softwareIdWorkers') }}
            </div>

        </div>
        <div class="entryBox triple" style="padding: 2px 7px" v-for="cc in filteredCCs" v-bind:key="cc.id">
          <div class="entryHeaderLight first">{{ cc.name }}</div>
          <div v-if="saves || !editieren" class="entryData">
            {{ cc.externalIdEmployee ? cc.externalIdEmployee : "&nbsp;" }}
          </div>
          <div v-if="saves || !editieren" class="entryData">{{ cc.externalIdWorker }}</div>
          <div v-if="!saves && editieren" class="entryData"><input v-model="cc.externalIdEmployee_input"/></div>
          <div v-if="!saves && editieren" class="entryData"><input v-model="cc.externalIdWorker_input"/></div>
          <br style="clear: both"/>
        </div>
      </div>

      <!-- Tarifgruppen -->
      <div v-if="employeeSyncSetting.wageGroups" class="xColumn2">
          <div class="header">
              {{ $t('settings.sync.tariffGroups') }}
          </div>

          <div class="entryBox triple">
              <div class="entryHeader first">&nbsp;</div>
              <div class="entryHeader">{{ $t('settings.sync.employees') }}</div>
              <div class="entryHeader">{{ $t('settings.sync.workers') }}</div>
          </div>
          <div v-if="saves || !editieren" class="entryBox triple">
              <div class="entryHeader first">
                  {{ $t('settings.sync.fullInsuredEmployee') }}
              </div>
          <div class="entryData">{{ wageGroup.fullyInsuredEmployee ? wageGroup.fullyInsuredEmployee : "&nbsp;" }}</div>
          <div class="entryData">{{ wageGroup.fullyInsuredWorker ? wageGroup.fullyInsuredWorker : "&nbsp;" }}</div>
        </div>
        <div v-if="saves || !editieren" class="entryBox triple">
            <div class="entryHeader first">
                {{ $t('settings.sync.marginalEmployee') }}
            </div>
            <div class="entryData">
            {{ wageGroup.marginallyEmployedEmployee ? wageGroup.marginallyEmployedEmployee : "&nbsp;" }}
          </div>
          <div class="entryData">
            {{ wageGroup.marginallyEmployedWorker ? wageGroup.marginallyEmployedWorker : "&nbsp;" }}
          </div>
        </div>
        <div v-if="saves || !editieren" class="entryBox triple">
            <div class="entryHeader first">
                {{ $t('settings.sync.apprentice') }}
            </div>
          <div class="entryData">{{ wageGroup.apprenticeEmployee ? wageGroup.apprenticeEmployee : "&nbsp;" }}</div>
          <div class="entryData">{{ wageGroup.apprenticeWorker ? wageGroup.apprenticeWorker : "&nbsp;" }}</div>
        </div>
        <!--        <div v-if="saves || !editieren" class="entryBox triple">-->
        <!--          <div class="entryHeader first">Freier Dienstnehmer</div>-->
        <!--          <div class="entryData">{{ wageGroup.independentContractorEmployee ? wageGroup.independentContractorEmployee : "&nbsp;"}}</div>-->
        <!--          <div class="entryData">{{ wageGroup.independentContractorWorker ? wageGroup.independentContractorWorker : "&nbsp;"}}</div>-->
        <!--        </div>-->
        <!--        <div v-if="saves || !editieren" class="entryBox triple">-->
        <!--          <div class="entryHeader first">Geringfügiger Freier Dienstnehmer</div>-->
        <!--          <div class="entryData">{{ wageGroup.marginallyEmployedIndependentContractorEmployee ? wageGroup.marginallyEmployedIndependentContractorEmployee : "&nbsp;"}}</div>-->
        <!--          <div class="entryData">{{ wageGroup.marginallyEmployedIndependentContractorWorker ? wageGroup.marginallyEmployedIndependentContractorWorker : "&nbsp;"}}</div>-->
        <!--        </div>-->
        <div v-if="!saves && editieren" class="entryBox triple">
            <div class="entryHeader first">
                {{ $t('settings.sync.fullInsuredEmployee') }}
            </div>
          <div class="entryData"><input v-model="wageGroup_input.fullyInsuredEmployee"/></div>
          <div class="entryData"><input v-model="wageGroup_input.fullyInsuredWorker"/></div>
        </div>
        <div v-if="!saves && editieren" class="entryBox triple">
            <div class="entryHeader first">
                {{ $t('settings.sync.marginalEmployee') }}
            </div>
          <div class="entryData"><input v-model="wageGroup_input.marginallyEmployedEmployee"/></div>
          <div class="entryData"><input v-model="wageGroup_input.marginallyEmployedWorker"/></div>
        </div>
        <div v-if="!saves && editieren" class="entryBox triple">
            <div class="entryHeader first">
                {{ $t('settings.sync.apprentice') }}
            </div>
          <div class="entryData"><input v-model="wageGroup_input.apprenticeEmployee"/></div>
          <div class="entryData"><input v-model="wageGroup_input.apprenticeWorker"/></div>
        </div>
        <!--        <div v-if="!saves && editieren" class="entryBox triple">-->
        <!--          <div class="entryHeader first">Freier Dienstnehmer</div>-->
        <!--          <div class="entryData"><input v-model="wageGroup_input.independentContractorEmployee" /></div>-->
        <!--          <div class="entryData"><input v-model="wageGroup_input.independentContractorWorker" /></div>-->
        <!--        </div>-->
        <!--        <div v-if="!saves && editieren" class="entryBox triple">-->
        <!--          <div class="entryHeader first">Geringfügiger Freier Dienstnehmer</div>-->
        <!--          <div class="entryData"><input v-model="wageGroup_input.marginallyEmployedIndependentContractorEmployee" /></div>-->
        <!--          <div class="entryData"><input v-model="wageGroup_input.marginallyEmployedIndependentContractorWorker" /></div>-->
        <!--        </div>-->
      </div>

      <!-- Bewertungsmodelle -->
      <div v-if="employeeSyncSetting.valuationModels" class="xColumn2">
          <div class="header">
              {{ $t('settings.sync.evaluationModels') }}
          </div>
          <div class="entryBox triple">
              <div class="entryHeader first">
                  {{ $t('settings.sync.allInModels') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">{{ valuationModel.allInModels ? valuationModel.allInModels : "&nbsp;" }}</div>
          <div v-if="!saves && editieren" class="entryData"><input v-model="valuationModel_input.allInModels"/></div>
        </div>
        <div class="entryBox triple">
          <div class="entryHeader first"> {{ $t('settings.sync.prioritization1') }}</div>
          <div v-if="saves || !editieren" class="entryData">{{ valuationModel.accPeriodPriority1Models ? valuationModel.accPeriodPriority1Models : "&nbsp;" }}</div>
          <div v-if="!saves && editieren" class="entryData"><input v-model="valuationModel_input.accPeriodPriority1Models"/></div>
        </div>
        <div class="entryBox triple">
          <div class="entryHeader first"> {{ $t('settings.sync.prioritization2') }}</div>
          <div v-if="saves || !editieren" class="entryData">{{ valuationModel.accPeriodPriority2Models ? valuationModel.accPeriodPriority2Models : "&nbsp;" }}</div>
          <div v-if="!saves && editieren" class="entryData"><input v-model="valuationModel_input.accPeriodPriority2Models"/></div>
        </div>
        <div class="entryBox triple">
          <div class="entryHeader first"> {{ $t('settings.sync.prioritization3') }}</div>
          <div v-if="saves || !editieren" class="entryData">{{ valuationModel.accPeriodPriority3Models ? valuationModel.accPeriodPriority3Models : "&nbsp;" }}</div>
          <div v-if="!saves && editieren" class="entryData"><input v-model="valuationModel_input.accPeriodPriority3Models"/></div>
        </div>

      </div>

      <!-- Standorte -->
      <div v-if="employeeSyncSetting.externalStoreId
              || employeeSyncSetting.costCenter
              || employeeSyncSetting.municipalitySerialNumber
              || employeeSyncSetting.allocationGroup
              || employeeSyncSetting.bankAccountOriginator"
           class="xColumn2">
          <div class="header">
              {{ $t('settings.sync.locations') }}
              <small class="text-secondary"><em>({{ $t('settings.sync.costCenters') }})</em></small>
          </div>

          <div class="entryBox" v-for="store in storesDataFiltered" :key="store.id + 'store'">
              <div class="entryHeader" style="margin-bottom:4px;">
                  {{ $t('settings.sync.locationName') }}
              </div>
              <div class="entryData" style="margin-bottom:4px;">
                  {{ store.name || "&nbsp;" }}
              </div>

              <div class="entryHeader" style="margin-bottom:4px;">
                  {{ $t('settings.sync.additionalText') }}
              </div>
              <div class="entryData" style="margin-bottom:4px;">
                  {{ store.description || "&nbsp;" }}
              </div>

              <div class="entryHeader" style="margin-bottom:4px;">
                  {{ $t('settings.sync.locationMdId') }}
              </div>
              <div class="entryData" style="margin-bottom:4px;">
                  {{ store.id || "&nbsp;" }}
              </div>

              <div class="entryHeader" style="margin-bottom:4px;">
                  {{ $t('settings.sync.locationBmdId') }}
              </div>
              <div v-if="saves || !editieren" class="entryData" style="margin-bottom:4px;">
                  {{ store.bmdId || "&nbsp;" }}
              </div>
              <div v-if="!saves && editieren" class="entryData" style="margin-bottom:4px;">
                  <input v-model="store.inputBmdId"/>
              </div>

              <div class="entryHeader" style="margin-bottom:4px;">
                  {{ $t('settings.sync.locationDpwId') }}
              </div>
              <div v-if="saves || !editieren" class="entryData" style="margin-bottom:4px;">
                  {{ store.dpwId || "&nbsp;" }}
              </div>
              <div v-if="!saves && editieren" class="entryData" style="margin-bottom:4px;">
                  <input v-model="store.inputDpwId"/>
              </div>

              <div class="entryHeader" style="margin-bottom:4px;">
                  {{ $t('settings.sync.locationCostCenterId') }}
              </div>
              <div v-if="saves || !editieren" class="entryData" style="margin-bottom:4px;">
                  {{ store.costCenter || "&nbsp;" }}
              </div>
              <div v-if="!saves && editieren" class="entryData" style="margin-bottom:4px;">
                  <input v-model="store.inputCostCenter"/>
              </div>

              <div class="entryHeader" style="margin-bottom:4px;">
                  {{ $t('settings.sync.locationMunicipalitySerial') }}
              </div>
              <div v-if="saves || !editieren" class="entryData" style="margin-bottom:4px;">
                  {{ store.municipalitySerialNumber || "&nbsp;" }}
              </div>
              <div v-if="!saves && editieren" class="entryData" style="margin-bottom:4px;">
                  <input v-model="store.inputMunicipalitySerialNumber"/>
              </div>

              <div class="entryHeader" style="margin-bottom:4px;">
                  {{ $t('settings.sync.locationDefaultAllocationGroup') }}
              </div>
              <div v-if="saves || !editieren" class="entryData" style="margin-bottom:4px;">
                  {{ store.allocationGroup || "&nbsp;" }}
              </div>
              <div v-if="!saves && editieren" class="entryData" style="margin-bottom:4px;">
                  <input v-model="store.inputAllocationGroup"/>
              </div>

              <div class="entryHeader" style="margin-bottom:4px;">
                  {{ $t('settings.sync.locationBankOriginator') }}
                  <i class="fa fa-circle-info"
                     v-tooltip="$t('settings.sync.bankOriginatorTooltip')" />
              </div>
              <div v-if="saves || !editieren" class="entryData" style="margin-bottom:4px;">
                  {{ store.bankAccountOriginator || "&nbsp;" }}
              </div>
              <div v-if="!saves && editieren" class="entryData" style="margin-bottom:4px;">
                  <input v-model="store.inputBankAccountOriginator"/>
              </div>

              <hr style="clear: both; margin-bottom: -12px"/>
          </div>
      </div>

      <!-- Fields -->
      <div class="xColumn2">
          <div class="header" style="width: 100%">
              {{ $t('settings.sync.employeeSyncFields') }}

              <i class="fas fa-redo" style="float: right; margin-top:2px;" @click="openResetDropdown();"/>
              <small class="text-secondary" style="float: right">
                  {{ ' ' + $t('settings.sync.resetToDefaults') + ' ' }}</small>
          </div>
        <div style="display: flex; padding: 5px;">
          <datatablesimple style="flex-basis: calc(100% - 25px)" :state="fieldsState"/>
        </div>
      </div>

      <br style="clear: both"/>
      <div style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 5px"></div>
    </div>

    <div class="parentBox" v-if="!loading && hasAccessRights && !otherError && companyData != null && employeeSyncSetting && stage === 2">

      <table class="table">
          <tr>
              <th>{{ $t('settings.sync.startedBy') }}</th>
              <th>{{ $t('settings.sync.exportStarted') }}</th>
              <th>{{ $t('settings.sync.exportFinished') }}</th>
              <th>{{ $t('global.ui.type') }}</th>
              <th>{{ $t('settings.sync.status') }}</th>
              <th>{{ $t('settings.sync.importedInExternalPayrollTool') }}</th>
              <th>{{ $t('settings.sync.downloadCsv') }}</th>
          </tr>
        <tr v-for="exportJob in exportJobsSorted" v-bind:key="exportJob.id">
          <td>{{ authusers[exportJob.authuserId].name }}</td>
          <td>{{ exportJob.jobStarted }}</td>
          <td>{{ exportJob.jobEnded }}</td>
            <td>{{
                    exportJob.manualDownload ? $t('settings.sync.manualDownload') : $t('settings.sync.exportToPayroll')
                }}</td>
            <td>
            <i v-if="exportJob.status === 'FAILED'" style="color: red" class="fas fa-xmark" v-on:click="selectedExportJob = exportJob; openExportJobStatusModal()"></i>
            <i v-if="exportJob.status === 'DONE'" style="color: green" class="fas fa-check"></i>
            <i v-if="exportJob.status === 'IGNORE-WARNING'" style="color: orange" class="fas fa-check" v-on:click="selectedExportJob = exportJob; openExportJobStatusModal()"></i>
            <i v-if="exportJob.status === 'WARNING'" style="color: orange" class="fas fa-check" v-on:click="selectedExportJob = exportJob; openExportJobStatusModal()"></i>
            <i v-if="exportJob.status === 'WARNING'" style="color: orange" class="fas fa-triangle-exclamation" v-on:click="selectedExportJob = exportJob; openExportJobStatusModal()"></i>
          </td>
          <td>
            <div>
              <i class="fas fa-check-circle checkbox" :key="'cb-ufdc-' + exportJob.id"
                 v-bind:class="{ false: !exportJob.useForDeltaCalculation }"
                 v-on:click="exportJob.useForDeltaCalculation = !exportJob.useForDeltaCalculation; setDeltaCalculationFlag(exportJob)"></i>
            </div>
          </td>
          <td>
            <i v-if="exportJob.exportCSV" class="fas fa-file-download" v-on:click="downloadCSVFromExportJob(exportJob.exportCSV)"></i>
          </td>
        </tr>
      </table>

    </div>

    <b-modal size="lg" ref="modal-ac-details" @close="closeAcDetailsModal()" centered>
      <template slot="modal-header">
        <div class="error-modal">
            <div class="headerlabel">
                {{ $t('settings.sync.collectiveAgreementDetails') }}
            </div>
        </div>
      </template>
      <b-container fluid>
        <div class="full">
          <table style="width: 100%">
            <tr>
              <th scope="col">ID</th>
              <td>{{ selectedAllowedContract.id }}</td>
            </tr>
            <tr>
              <th scope="col">Store ID</th>
              <td>{{ selectedAllowedContract.storeId }}</td>
            </tr>
            <tr>
              <th scope="col">Store</th>
              <td>{{ Object.keys(selectedAllowedContract).length > 0 ? JSON.parse(JSON.stringify(storesDataFiltered.find(store => store.id === selectedAllowedContract.storeId))).name : ""}}</td>
            </tr>
            <tr>
              <th scope="col">KV Name</th>
              <td>{{ Object.keys(selectedAllowedContract).length > 0 ? collectiveContractMap[selectedAllowedContract.collectiveContractId].name : ""}}</td>
            </tr>
            <tr>
              <th scope="col">Wochentage</th>
              <td>{{ selectedAllowedContract.weekWorkDaysRegular }}</td>
            </tr>
            <tr>
              <th scope="col">{{ $t('employee.contract.weeklyHours') }}</th>
              <td>{{ Math.round(((selectedAllowedContract.weekTimeRegular / 60.0) + Number.EPSILON) * 100) / 100 }}</td>
            </tr>
            <tr>
              <th scope="col">{{ $t('employee.contract.additionalMonthlyHours') }}</th>
              <td>{{ Math.round(((selectedAllowedContract.additionalMonthWorkTime / 60.0) + Number.EPSILON) * 100) / 100 }}</td>
            </tr>

          </table>
        </div>
      </b-container>
      <template slot="modal-footer">
        <div class="button right" @click="closeAcDetailsModal()">
          <div class="label">{{ $t('global.ui.close') }}</div>
        </div>
      </template>
    </b-modal>

    <b-modal size="lg" ref="modal-exportjob-status" @close="closeExportJobStatusModal()" centered>
      <template slot="modal-header">
        <div class="error-modal">
          <div class="headerlabel">{{ $t('export.comp.exportDetails') }}</div>
        </div>
      </template>
      <b-container fluid>
          <div v-if="selectedExportJob && selectedExportJob.status === 'FAILED'" class="full">
              {{ $t('settings.sync.exportFailed') }}
          </div>
          <div v-if="selectedExportJob && selectedExportJob.status === 'IGNORE-WARNING'" class="full">
              {{ $t('settings.sync.exportSuccess') }}<br>
              {{ $t('settings.sync.skippedEmployeesInfo') }}<br>

              <table v-if="getInactiveEmployeeWarnings(selectedExportJob).length > 0">
                  <th><td><br>{{ $t('settings.sync.skippedInactiveEmployees') }}</td></th>
                  <tr v-for="emp in getInactiveEmployeeWarnings(selectedExportJob)" :key="emp.employeeId">
                      <td>{{ getEmployeeName(emp.employeeId) }}</td>
                  </tr>
              </table>

              <table v-if="getExternalEmployeeWarnings(selectedExportJob).length > 0">
                  <th><td><br>{{ $t('settings.sync.skippedExternalEmployees') }}</td></th>
                  <tr v-for="emp in getExternalEmployeeWarnings(selectedExportJob)" :key="emp.employeeId">
                      <td>{{ getEmployeeName(emp.employeeId) }}</td>
                  </tr>
              </table>

              <table v-if="getHiddenEmployeeWarnings(selectedExportJob).length > 0 && showHiddenWarnings">
                  <th>
                      <td><br>{{ $t('settings.sync.skippedHiddenEmployees') }}
                          <i class="fas fa-chevron-circle-up" style="padding-left: 5px" @click="showHiddenWarnings = !showHiddenWarnings"/>
                      </td>
                  </th>
                  <tr v-for="emp in getHiddenEmployeeWarnings(selectedExportJob)" :key="emp.employeeId">
                      <td>{{ getEmployeeName(emp.employeeId) }}</td>
                  </tr>
              </table>

              <table v-if="getHiddenEmployeeWarnings(selectedExportJob).length > 0 && !showHiddenWarnings">
                  <th>
                      <td><br>{{ $t('settings.sync.skippedHiddenEmployees') }}
                          <i class="fas fa-chevron-circle-down" style="padding-left: 5px" @click="showHiddenWarnings = !showHiddenWarnings"/>
                      </td>
                  </th>
              </table>
          </div>
          <div v-if="selectedExportJob && selectedExportJob.status === 'WARNING'" class="full">
              {{ $t('settings.sync.exportSuccess') }}<br>
              {{ $t('settings.sync.warningsOccurred') }}<br>

              <table v-for="table in getOtherWarningsTable(selectedExportJob)" :key="table.name">
                  <th><td><br>{{ warningTranslations[table.name] }}</td></th>
                  <tr v-for="empId in table.emps" :key="empId">
                      <td>{{ getEmployeeName(empId) }}</td>
                  </tr>
              </table>

              <!-- The same skipped employee blocks reused -->
              <table v-if="getInactiveEmployeeWarnings(selectedExportJob).length > 0">
                  <th><td><br>{{ $t('settings.sync.skippedInactiveEmployees') }}</td></th>
                  <tr v-for="emp in getInactiveEmployeeWarnings(selectedExportJob)" :key="emp.employeeId">
                      <td>{{ getEmployeeName(emp.employeeId) }}</td>
                  </tr>
              </table>

              <table v-if="getExternalEmployeeWarnings(selectedExportJob).length > 0">
                  <th><td><br>{{ $t('settings.sync.skippedExternalEmployees') }}</td></th>
                  <tr v-for="emp in getExternalEmployeeWarnings(selectedExportJob)" :key="emp.employeeId">
                      <td>{{ getEmployeeName(emp.employeeId) }}</td>
                  </tr>
              </table>

              <table v-if="getHiddenEmployeeWarnings(selectedExportJob).length > 0 && showHiddenWarnings">
                  <th>
                      <td><br>{{ $t('settings.sync.skippedHiddenEmployees') }}
                          <i class="fas fa-chevron-circle-up" style="padding-left: 5px" @click="showHiddenWarnings = !showHiddenWarnings"/>
                      </td>
                  </th>
                  <tr v-for="emp in getHiddenEmployeeWarnings(selectedExportJob)" :key="emp.employeeId">
                      <td>{{ getEmployeeName(emp.employeeId) }}</td>
                  </tr>
              </table>

              <table v-if="getHiddenEmployeeWarnings(selectedExportJob).length > 0 && !showHiddenWarnings">
                  <th>
                      <td><br>{{ $t('settings.sync.skippedHiddenEmployees') }}
                          <i class="fas fa-chevron-circle-down" style="padding-left: 5px" @click="showHiddenWarnings = !showHiddenWarnings"/>
                      </td>
                  </th>
              </table>
          </div>
      </b-container>
      <template slot="modal-footer">
        <div v-if="selectedExportJob && selectedExportJob.status === 'FAILED'" class="button right"
             @click="openInNewTab('https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/11'); closeExportJobStatusModal()">
            <div class="label">
                {{ $t('settings.sync.contactSupport') }}
            </div>
        </div>
        <div class="button right" @click="closeExportJobStatusModal()">
          <div class="label">{{ $t('global.ui.close') }}</div>
        </div>
      </template>
    </b-modal>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import VueEventBus from "@/vue-event-bus";

export default {
  name: "employeesyncsettings",
  data() {
    return {
      stage: 1,

        payslipPasswordSettings: [
            {
                value: 0,
                label: this.$t('settings.sync.payslipPassword4DigitSvnr'),
            },
            {
                value: 1,
                label: this.$t('settings.sync.payslipPassword10DigitSvnr'),
            }
        ],
        periodicExportTimeTypes: [
            {
                value: 0,
                label: this.$t('settings.sync.timeDaily'),
            },
            {
                value: 1,
                label: this.$t('settings.sync.timeWeekly'),
            },
            {
                value: 2,
                label: this.$t('settings.sync.timeMonthly'),
            }
        ],
        bmdImportScriptFunctions: [
            {
                value: "MCS_FRMLOHNMITARBEITERCSVIMPORT_CREATE",
                label: this.$t('settings.sync.importEmployeeData')
            },
            {
                value: "MCS_FRMABRECHNUNGCSVIMPORT_CREATE",
                label: this.$t('settings.sync.importFinancialStatements')
            },
            {
                value: "MCS_FRMABWESENHEITCSVIMPORT_CREATE",
                label: this.$t('settings.sync.importAbsenceData')
            }
        ],
        bmdImportScriptFunctionFolder: {
            MCS_FRMLOHNMITARBEITERCSVIMPORT_CREATE: "employeeData",
            MCS_FRMABRECHNUNGCSVIMPORT_CREATE: "monthlyFinancialStatementData",
            MCS_FRMABWESENHEITCSVIMPORT_CREATE: "absenceData",
        },
        enumEmployeeChangedFromBMDModes: {
            0: this.$t('settings.sync.employeeChangesConfirm'),
            1: this.$t('settings.sync.employeeChangesApplyImmediately'),
        },

      loading: true,
      longLoading: false,
      loadingDownload: false,
      loadingExport: false,

      editieren: false,

      companyData: null,
      storesData: null,

      internalId: "",
      companyName: "",
      companyDescription: "",
      bmdId: "",
      dpwId: "",
      companyNumber: "",

      inputBmdId: "",
      inputDpwId: "",
      inputCompanyNumber: "",

      collectiveContractMappingArray: [],
      collectiveContractMap: {},
      collectiveContractArray: [],

      allowedContractArray: [],
      selectedAllowedContract: {},

      contractWeekModelNrMappingArray: [],
      contractWeekModelNrMap: {},
      contractWeekModelNrArray: [],
      similarContractWeekModelNrArray: [],
      similarContractWeekModelNrArray_input: [],
      combineSimilarContracts: true,
      hideDeactivatedContracts: true,
      hideUnusedCollectiveContracts: true,

      employeeSyncSetting: null,
      employeeSyncSettingsData: {
        id: -1,
        taxOfficeSerialNumber: "",
        enableExportViaTransferService: false,
        enablePeriodicExport: false,
        employeeChangeMode: 0,
        employeeAutoCreate: false,
        costCenterAutoCreate: false,
      },
      employeeSyncSettingsData_input: {
        id: -1,
        taxOfficeSerialNumber: "",
        enableExportViaTransferService: false,
        enablePeriodicExport: false,
        employeeChangeMode: 0,
        employeeAutoCreate: false,
        costCenterAutoCreate: false,
      },

      selectedProfileId: 0,
      exportProfiles: [],
      exportProfiles_input: [],

      employeeSyncFieldSettings: [],

      wageGroup: {
        id: -1,
        fullyInsuredEmployee: "",
        fullyInsuredWorker: "",
        marginallyEmployedEmployee: "",
        marginallyEmployedWorker: "",
        apprenticeEmployee: "",
        apprenticeWorker: "",
        independentContractorEmployee: "",
        independentContractorWorker: "",
        marginallyEmployedIndependentContractorEmployee: "",
        marginallyEmployedIndependentContractorWorker: "",
      },
      wageGroup_input: {
        id: -1,
        fullyInsuredEmployee: "",
        fullyInsuredWorker: "",
        marginallyEmployedEmployee: "",
        marginallyEmployedWorker: "",
        apprenticeEmployee: "",
        apprenticeWorker: "",
        independentContractorEmployee: "",
        independentContractorWorker: "",
        marginallyEmployedIndependentContractorEmployee: "",
        marginallyEmployedIndependentContractorWorker: "",
      },

      valuationModel: {
        id: -1,
        allInModels: "",
        accPeriodPriority1Models: "",
        accPeriodPriority2Models: "",
        accPeriodPriority3Models: "",
      },
      valuationModel_input: {
        id: -1,
        allInModels: "",
        accPeriodPriority1Models: "",
        accPeriodPriority2Models: "",
        accPeriodPriority3Models: "",
      },

      periodicExportTimes: [],
      periodicExportTimes_input: [],

      exportJobs: [],
        warningTranslations: {
            "Removed IBAN: IBAN is not valid.": this.$t('settings.sync.warning.ibanInvalid'),
            "Removed SVNR: SVNR is not valid.": this.$t('settings.sync.warning.svnrInvalid'),
            "Employee skipped: No StoreId": this.$t('settings.sync.warning.noStoreAssigned'),
        },
        ignorableWarnings: [
            this.$t('settings.sync.ignorable.externalEmployee'),
            this.$t('settings.sync.ignorable.inactiveEmployee'),
        ],
        hardIgnorableWarnings: [
            this.$t('settings.sync.hardIgnorable.hiddenEmployee'),
        ],
      showHiddenWarnings: false,
      authusers: [],
      selectedExportJob: null,

      saves: false,
      hasAccessRights: true,
      otherError: false,
      otherErrorMessage: "",
    };
  },
  created: function () {
    //console.log("CREATED");
    VueEventBus.$on("JobEmployeeExportEvent:jobCreated", this.jobCreated);
    VueEventBus.$on("JobEmployeeExportEvent:jobStarted", this.jobStarted);
    VueEventBus.$on("JobEmployeeExportEvent:jobEnded", this.jobEnded);
    VueEventBus.$on("JobEmployeeExportEvent:jobFailed", this.jobFailed);
  },
  beforeDestroy: function () {
    VueEventBus.$off("JobEmployeeExportEvent:jobCreated", null);
    VueEventBus.$off("JobEmployeeExportEvent:jobStarted", null);
    VueEventBus.$off("JobEmployeeExportEvent:jobEnded", null);
    VueEventBus.$off("JobEmployeeExportEvent:jobFailed", null);
  },
  mounted: function () {
    if (this.$store.state.jwt != undefined && this.$store.state.companyId != undefined) {

      this.refresh();
    }
  },
  computed: {
    ...mapGetters([
      "companyId",
      "isSuperUser",
      "externalServicesMap",
      "companySettings",
      "selectedStores",
      "employeeArray",
      "externalSoftwaresMap",
    ]),
    dateDisplay: function () {
      return this.$helpers.getMomentTZ().format("YYYY-MM-DD");
    },
    softwareId() {
      if (this.companyData != null && this.companyData.softwareId != null) {
        return this.companyData.softwareId;
      } else {
        return -1;
      }
    },
    headerButtons() {
      let view = this;

      let state = {
        buttons: [
          {
            type: "block border-r",
            icon: "fa-edit",
            show: view.stage === 1 && !view.saves && !view.editieren,
            disabled: view.loading || view.loadingDownload || view.loadingExport,
            click: () => {
              view.editieren = !view.editieren;
            },
            tooltip: view.$t('settings.ui.edit'),
            title: view.$t('settings.ui.edit'),
          },
          {
            type: view.employeeSyncSettingsData.enableExportViaTransferService ? "block" : "block border-r",
            icon: "fa-file-download",
            show: view.stage === 1 && view.employeeSyncSetting && !view.loadingDownload && !view.saves && !view.editieren,
            disabled: view.loading || view.loadingExport || view.employeeSyncSettingsData.id === -1,
            click: () => {
              view.openDownloadCsvPopup();
            },
            tooltip:  view.$t('settings.sync.downloadExport') ,
            title:  view.$t('settings.sync.downloadExport') ,
          },
          {
            show: view.stage === 1 && view.loadingDownload,
            type: view.employeeSyncSettingsData.enableExportViaTransferService ? "block" : "block border-r",
            icon: "fa-spinner fa-spin",
            click: () => {
            },
            tooltip:  view.$t('settings.sync.downloadGen') ,
          },
          {
            type: "block border-r",
            icon: "fa-file-export",
            show: view.stage === 1 && !view.loadingExport && !view.saves && !view.editieren && view.employeeSyncSetting && view.employeeSyncSettingsData.enableExportViaTransferService,
            disabled: view.loading || view.loadingDownload,
            click: () => {
              view.openExportCsvPopup();
            },
            tooltip:  view.$t('settings.sync.exportLV') ,
            title:  view.$t('settings.sync.exportLV') ,
          },
          {
            show: view.stage === 1 && view.loadingExport,
            type: "block border-r",
            icon: "fa-spinner fa-spin",
            click: () => {
            },
            tooltip:  view.$t('settings.sync.downloadGen') ,
          },
          {
            type: "block border-r",
            icon: "fa-magnifying-glass",
            show: view.stage === 1 && !view.saves && !view.editieren && ((view.employeeSyncSetting && view.employeeSyncSettingsData.enableExportViaTransferService) || view.exportJobsSorted.length > 0),
            disabled: view.loading || view.loadingDownload || view.loadingExport,
            click: () => {
              view.stage = 2;
            },
            tooltip:  view.$t('settings.sync.viewExport') ,
            title:  view.$t('settings.sync.viewExport') ,
          },
          {
            type: "block border-r",
            icon: "fa-chevron-left",
            show: view.stage === 2,
            click: () => {
              view.stage = 1;
            },
            tooltip:  view.$t('settings.sync.backToSettings') ,
            title:  view.$t('settings.sync.backToSettings') ,
          },
          {
            type: "block red",
            icon: "fa-ban",
            show: view.stage === 1 && !view.saves && view.editieren,
            click: () => {
              view.resetInputs();
              view.editieren = !view.editieren;
            },
            tooltip: view.$t('settings.ui.cancel'),
          },
          {
            type: "block green",
            icon: "fa-save",
            show: view.stage === 1 && !view.saves && view.editieren,
            click: () => {
              view.save();
            },
            tooltip:  view.$t('settings.ui.saveChanges') ,
          },
          {
            show: view.stage === 1 && view.saves,
            type: "block",
            icon: "fa-spinner fa-spin",
            click: () => {
            },
            tooltip:  view.$t('settings.ui.saving') ,
          },
        ],
          helperLinks: [
              {
                  title: view.$t('settings.help.empSyncTitle'),
                  helperText: view.$t('settings.help.empSyncText'),
                  externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2599256065",
                  externalLabel: view.$t('settings.help.learnMore'),
                  cancelLabel: view.$t('settings.help.thanks'),
                  icon: "fa-rotate"
              },
              {
                  title: view.$t('settings.help.supportTitle'),
                  helperText: view.$t('settings.help.supportText'),
                  externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/11",
                  externalLabel: view.$t('settings.help.contactSupport'),
                  cancelLabel: view.$t('global.ui.close')
              }
          ]
      };
      return state;
    },
    sideButtons() {
      let view = this;

      let state = {
        buttons: [
          {
            type: "block",
            icon: "fa-bars",
            tooltip:  view.$t('settings.help.additionalDownloads') ,
            click: ($event) => {
              view.OpenMenuDetails($event, this.downloadsMenuState);
            },
          }
        ],
      };
      return state;
    },
    downloadsMenuState(){
      let view = this;
      let state = {
        componentref: 'burgermenustate',
        groups: [],
        items: []
      };
      let group1 = {
        label:  view.$t('settings.help.additionalDownloads') ,
        items: [
          {
            closeOnClick: true,
            icon: "fa-folder-arrow-down",
            show: this.softwareId === 0,
            disabled: view.loadingDownload || view.loadingExport,
            text: view.$t('settings.help.bmdImportEmployeeGenerate'),
            click: () => { view.downloadImportBmdInterface(); },
          },
          {
            closeOnClick: true,
            icon: "fa-file-arrow-down",
            show: this.softwareId === 0,
            disabled: view.loadingDownload || view.loadingExport,
            text: view.$t('settings.help.bmdMacroSvnrCheck'),
            click: () => { view.openSvnrCheckMakroPopup() },
          },
          {
            closeOnClick: true,
            icon: "fa-folder-arrow-down",
            show: this.softwareId === 0,
            disabled: view.loadingDownload || view.loadingExport,
            text: view.$t('settings.help.bmdExportEmployee'),
            click: () => { view.downloadExportBmdInterface() },
          },
          {
            closeOnClick: true,
            icon: "fa-file-arrow-down",
            show: this.softwareId === 0,
            disabled: view.loadingDownload || view.loadingExport,
              text: view.$t('settings.help.bmdMacroValidFrom'),
            click: () => { view.openValidFromMakroPopup() },
          },
          {
            closeOnClick: true,
            icon: "fa-file-arrow-down",
            show: this.softwareId === 0,
            disabled: view.loadingDownload || view.loadingExport,
              text: view.$t('settings.help.bmdFormulaWageKv'),
            click: () => { view.openWageFormulaPopup() },
          },
          // {
          //   closeOnClick: true,
          //   icon: "fa-file-arrow-down",
          //   show: this.softwareId === 0,
          //   disabled: view.loadingDownload || view.loadingExport,
          //   text: "BMD Zugangsdaten für Import via Kommandozeile generieren",
          //   click: () => { view.openBmdLoginDataPopup() },
          // },
          // {
          //   closeOnClick: true,
          //   icon: "fa-file-arrow-down",
          //   show: this.softwareId === 0,
          //   disabled: view.loadingDownload || view.loadingExport,
          //   text: "BMD Import Script für Import via Kommandozeile generieren",
          //   click: () => { view.openBmdImportScriptPopup() },
          // },
          {
            closeOnClick: true,
            icon: "fa-folder-arrow-down",
            show: this.softwareId === 0,
            disabled: view.loadingDownload || view.loadingExport,
              text: view.$t('settings.help.bmdImportFolderStructureDownload'),
            click: () => { view.openBmdEditelFolderStructurePopup() },
          },
          {
            closeOnClick: true,
            icon: "fa-folder-arrow-down",
            show: this.softwareId === 0,
            disabled: view.loadingDownload || view.loadingExport,
              text: view.$t('settings.help.bmdEmployeeImportMacroAndBatchDownload'),
            click: () => { view.openEmployeeImportStapelPopup() },
          },
          {
            closeOnClick: true,
            icon: "fa-folder-arrow-down",
            show: this.softwareId === 0,
            disabled: view.loadingDownload || view.loadingExport,
              text: view.$t('settings.help.bmdEmployeeExportBatchDownload'),
            click: () => { view.openEmployeeExportStapelPopup() },
          },
          {
            closeOnClick: true,
            icon: "fa-file-times",
            show: this.softwareId !== 0,
            disabled: true,
              text: view.$t('settings.help.noDownloadsForYourPayrollTool'),
          },
        ]
      }

      state.groups.push(group1);

      return state;
    },
    storesDataFiltered() {
      let filtered = [];
      this.storesData.forEach((s) => {
        /*if (
          this.selectedStores.filter((elem) => {
            return s.id == elem.id;
          }).length > 0
        )*/
        filtered.push(s);
      });
      return filtered;
    },
    fieldsState() {
      let view = this;
      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
            listStructure: view.$t('settings.help.exportStructure'),
            columns: view.$t('settings.help.customFieldLabels')
        },
        Object.values(this.employeeSyncFieldSettings)
      );

      state.headerMap.listStructure.componentStateBuilders = [
        (data, entry) => {
          if (data.disabled === undefined) {
            return {};
          } else {
            return {
              componentType: "buttonc",
              label: data.defaultName,
              type: "occupy-container",
                tooltip: data.disabled === true
                    ? this.$t('settings.help.fieldUnavailable')
                    : this.$t('settings.help.selectDeselect'),
                class: `${data.showField === 1 && !data.disabled ? "selected" : ""}`,
              customEvents: {
                click: () => {
                  if (!data.disabled) {
                    data.showField === 1 ? data.showField = 0 : data.showField = 1;
                    view.saveEmployeeSyncFieldSettings();
                    view.$forceUpdate();
                  }
                },
              },
              style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
              styleLabel: {"text-align": "left", width: "100%"},
            };
          }
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "inputc",
            inputProp: data.fieldName,
            placeholder: data.fieldName,
            style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
            customEvents: {
              Update: (val) => {
                data.fieldName = val;
                view.saveEmployeeSyncFieldSettings();
                view.$forceUpdate();
              },
            },
          };
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = {"justify-content": "start"}));
      state.compact = true;
      state.draggable = true;
      state.dragOptions = {
        handle: ".fa-up-down",
        onStart: function (/**Event*/event) {
          // remove strange "glow" from "transform: translateZ(0px)"
          event.item.style.transform = null;
        },
        onUpdate(/**Event*/event) {
          view.updateFieldOrder(event.oldIndex + 1, event.newIndex + 1);
          view.saveEmployeeSyncFieldSettings();
        }
      };
      return state;
    },
    filteredCCs() {
      if (this.collectiveContractMappingArray.length === 0) {
        return [];
      } else if (this.filteredAllowedContracts.length === 0 || !this.hideUnusedCollectiveContracts) {
        return this.collectiveContractMappingArray;
      } else {
        let ccs = new Set();
        this.filteredAllowedContracts.forEach(storeArray => {
          storeArray.forEach(ac => {
            ccs.add(ac.collectiveContractId);
          });
        });
        return this.collectiveContractMappingArray.filter(cc => {
          return ccs.has(cc.mdId);
        });
      }
    },
    similarAllowedContracts() {
      let similarAllowedContracts = {};
      this.filteredAllowedContracts.forEach(storeContracts => {
        storeContracts.forEach(ac => {
          if (!(ac.collectiveContractId in similarAllowedContracts)) {
            similarAllowedContracts[ac.collectiveContractId] = {};
          }
          if (!(ac.weekWorkDaysRegular in similarAllowedContracts[ac.collectiveContractId])) {
            similarAllowedContracts[ac.collectiveContractId][ac.weekWorkDaysRegular] = {};
          }
          if (!(ac.weekTimeRegular in similarAllowedContracts[ac.collectiveContractId][ac.weekWorkDaysRegular])) {
            similarAllowedContracts[ac.collectiveContractId][ac.weekWorkDaysRegular][ac.weekTimeRegular] = {};
          }
          if (ac.externalId) {
            similarAllowedContracts[ac.collectiveContractId][ac.weekWorkDaysRegular][ac.weekTimeRegular][ac.externalId] = {};
          }
        })
      });

      // copy computed values to separate arrays to handle user inputs
      this.similarContractWeekModelNrArray = JSON.parse(JSON.stringify(similarAllowedContracts));
      for (const collectiveContractArray in this.similarContractWeekModelNrArray) {
        for (const weekWorkDaysArray in this.similarContractWeekModelNrArray[collectiveContractArray]) {
          for (const weekTimeArray in this.similarContractWeekModelNrArray[collectiveContractArray][weekWorkDaysArray]) {
            this.similarContractWeekModelNrArray[collectiveContractArray][weekWorkDaysArray][weekTimeArray] =
              this.printAssoArray(this.similarContractWeekModelNrArray[collectiveContractArray][weekWorkDaysArray][weekTimeArray]);
          }
        }
      }
      this.similarContractWeekModelNrArray_input = JSON.parse(JSON.stringify(this.similarContractWeekModelNrArray));

      return similarAllowedContracts;
    },
    filteredAllowedContracts() {
      let filteredAllowedContracts = [];
      this.allowedContractArray.forEach(storeArray => {
        let filteredStoreArray = [];
        storeArray.forEach(ac => {
          if (!this.hideDeactivatedContracts || ac.active) {
            filteredStoreArray.push(ac);
          }
        });
        if (filteredStoreArray.length > 0) {
          filteredAllowedContracts.push(filteredStoreArray);
        }
      });
      return filteredAllowedContracts;
    },
    exportJobsSorted() {
      return this.exportJobs.sort((a,b) => {
        if (a.created_at > b.created_at) {
          return -1;
        } else if (b.created_at > a.created_at) {
          return 1;
        } else {
          return 0;
        }
      });
    },
    selectedProfile() {
      return this.exportProfiles.find((profile) => profile.id === this.selectedProfileId) || {};
    },
    selectedProfileInput() {
      return this.exportProfiles_input.find((profile) => profile.id === this.selectedProfileId) || {};
    }
  },
  watch: {
    companyId: function (val, oldVal) {
      this.refresh();
    },
    selectedStores: function (val, oldVal) {
      console.log("Selected stores changed in CompanySettings.vue");
      console.log(oldVal);
      console.log(val);
    },
    periodicExportTimes_input: {
      handler (val, oldVal) {
        val.forEach(time => {
          let hours = parseInt(time.hours);
          if (hours > 23) {
            time.hours = 23;
          } else if (hours < 10) {
            time.hours = "0" + hours;
          } else {
            time.hours = hours;
          }

          let minutes = parseInt(time.minutes);
          if (minutes > 59) {
            time.minutes = 59;
          } else if (minutes < 10) {
            time.minutes = "0" + minutes;
          } else {
            time.minutes = minutes;
          }
        });
      },
      deep: true,
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {
      let view = this;
      view.loading = true;

      view.exportProfiles = [{
        id: -1,
        label: view.$t('report.comp.standard'),
        isDefault: true,
        payslipPassword: 0,
        exportLastNameBlockLetters: true,
        exportLatestContractOnly: true,
        ignoreExternalEmployees: true,
        ignoreHiddenEmployees: true,
        ignoreInactiveEmployees: true,
        exportUnchangedEmployees: true,
        exportChangedEmployees: true,
        exportNewEmployees: true,
      }];
      view.exportProfiles_input = JSON.parse(JSON.stringify(view.exportProfiles));

      view.$helpers.GetEmployeeArray();
      view.prepareCollectiveContracts();
      view.prepareWageGroups();
      view.prepareValuationModels();
      view.preparePeriodicExportTimes();
      view.loadPeriodicExportTimes();
      view.loadExportJobs();
      view.$helpers.GetExternalSoftwaresMap();
      view.$helpers
        .GetCompanySettings(force)
        .then((response) => {
          view.updateCompanySettings(response);
          view.prepareEmployeeSyncSettings();
          view.getEmployeeSyncFields();
          return view.$helpers.GetStoresSettings(force)
        })
        .then((response) => {
          view.storesData = response.data;

          view.allowedContractArray = [];
          let promises = [];
          for (let i = 0; i < view.storesData.length; i++) {
            view.storesData[i].inputBmdId = view.storesData[i].bmdId;
            view.storesData[i].inputDpwId = view.storesData[i].dpwId;
            view.storesData[i].inputCostCenter = view.storesData[i].costCenter;
            view.storesData[i].inputStoreNumber = view.storesData[i].storeNumber;
            view.storesData[i].inputMunicipalitySerialNumber = view.storesData[i].municipalitySerialNumber;
            view.storesData[i].inputAllocationGroup = view.storesData[i].allocationGroup;
            view.storesData[i].inputBankAccountOriginator = view.storesData[i].bankAccountOriginator;

            promises.push(this.loadAllowedContracts(view.storesData[i].id));
          }
          Promise.all(promises).then((response) => {
            view.prepareContractWeekModelNrs()
              .then((response) => {
                view.resetInputs();
                view.loading = false;
              });
          });
        })
        .catch((error) => {
          console.log("REFRESH ERROR: " + error);
            view.$helpers.error(
                view.$t('global.messages.error'),
                view.$t('settings.ui.errorLoadingData')
            );

            if (error && error.response && error.response.status == 403) {
            view.hasAccessRights = false;
          }
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            view.otherErrorMessage = error.response.data.message;
          }
          view.otherError = true;
          //view.$helpers.error('Fehler', 'Fehler beim Laden der Daten');
          setTimeout(function () {
            view.loading = false;
          }, 200);
        });
    },
    resetInputs() {
      let view = this;

      view.inputBmdId = view.bmdId;
      view.inputDpwId = view.dpwId;
      view.inputCompanyNumber = view.companyNumber;

      view.employeeSyncSettingsData_input = JSON.parse(JSON.stringify(view.employeeSyncSettingsData));
      view.exportProfiles_input = JSON.parse(JSON.stringify(view.exportProfiles));
      view.periodicExportTimes_input = JSON.parse(JSON.stringify(view.periodicExportTimes));
      view.selectedProfileId = view.exportProfiles.find(profile => profile.id === view.selectedProfileId)
        ? view.selectedProfileId : (view.exportProfiles.find(profile => profile.isDefault) ? view.exportProfiles.find(profile => profile.isDefault).id : null);
      view.wageGroup_input = JSON.parse(JSON.stringify(view.wageGroup));
      view.valuationModel_input = JSON.parse(JSON.stringify(view.valuationModel));

      view.collectiveContractMappingArray.forEach((obj) => {
        obj.externalIdEmployee_input = obj.externalIdEmployee;
        obj.externalIdWorker_input = obj.externalIdWorker;
      });

      view.storesDataFiltered.forEach((store) => {
        store.inputBmdId = store.bmdId;
        store.inputDpwId = store.dpwId;
      });

      Object.values(view.allowedContractArray).forEach(acperstore => {
        Object.values(acperstore).forEach(ac => {
          ac.externalId_input = ac.externalId;
        })
      });
      view.similarContractWeekModelNrArray_input = view.similarContractWeekModelNrArray;

    },

    // menu
    OpenMenuDetails($event, state){
      let view = this;

      this.$helpers.OpenPopup({
        type: 'burgermenu',
        componentState: state,
        listStyle: true,
        noScroll: true,
        pointerDirection: 0,
        elRelative: $event.currentTarget,
        pointerOffset: -15,
      });
    },

    // collective contracts
    prepareCollectiveContracts() {
      let view = this;
      view.collectiveContractMappingArray = [];
      view.collectiveContractMap = {};
      view.collectiveContractArray = [];
      view.getCollectiveContractMap(true)
        .then((resp) => {
          // Object.values(resp).forEach(obj => {console.log(obj.name)});
          // Object.values(view.collectiveContractMap).forEach(obj => {console.log(obj.name)});
          view.getCollectiveContractMapping()
            .then((mapping) => {
              console.log("mapping", mapping);
              Object.values(view.collectiveContractMap).forEach(obj => {
                let result = mapping.find(res => {
                  return res.mdId === obj.id
                });
                let nameChanged = obj.country === 2 ? obj.name + " (DE)" : obj.name;
                obj.name = nameChanged;
                let push = {
                  name: nameChanged,
                  mdId: obj.id,
                  externalIdEmployee_input: null,
                  externalIdWorker_input: null
                };
                if (result !== undefined) {
                  push.externalIdEmployee = result.externalIdEmployee;
                  push.externalIdWorker = result.externalIdWorker;
                  push.externalIdEmployee_input = result.externalIdEmployee;
                  push.externalIdWorker_input = result.externalIdWorker;
                  push.id = result.id;
                }
                view.collectiveContractMappingArray.push(push);
              });
              // view.collectiveContractMappingArray.forEach(obj => {console.log(obj.name)});
            });
        });
    },
    getCollectiveContractMap(force = false, asArray = false) {
      if (this.collectiveContractMap && !force) {
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(this.collectiveContractMap, asArray));
        });
      } else {
        return this.$helpers.GetCall('/api/sec/proxy/md/collectiveContracts').then((response) => {
          let map = {};
          response.data.forEach(collectiveContract => {
            map[collectiveContract.id] = collectiveContract;
          });
          this.collectiveContractMap = map;
          this.collectiveContractArray = this.$helpers.returnObj(map, true);
          return new Promise((resolve, reject) => {
            resolve(this.$helpers.returnObj(map, asArray));
          });
        }).catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
      }
    },
    getCollectiveContractMapping() {
      return this.$helpers.GetCall('/api/sec/employeesync/collectiveContracts').then((response) => {
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(response.data.data, false));
        });
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    },
    saveCollectiveContracts() {
      let view = this;
      let objects = [];
      Object.values(view.collectiveContractMappingArray).forEach(cc => {
        let object = JSON.parse(JSON.stringify(cc));
        object.externalIdEmployee = cc.externalIdEmployee_input;
        object.externalIdWorker = cc.externalIdWorker_input;
        if ((cc.hasOwnProperty("externalIdEmployee") && cc.externalIdEmployee !== cc.externalIdEmployee_input)
          || (cc.hasOwnProperty("externalIdWorker") && cc.externalIdWorker !== cc.externalIdWorker_input)) {
          // cc mapping exists and has updated values
          objects.push(object);
        } else if ((!cc.hasOwnProperty("externalIdEmployee") && cc.externalIdEmployee_input !== null && cc.externalIdEmployee_input !== "")
          || (!cc.hasOwnProperty("externalIdWorker") && cc.externalIdWorker_input !== null && cc.externalIdWorker_input !== "")) {
          // cc mapping doesn't exist, but value is not empty
          objects.push(object);
        }
        // cc mapping exists, but no updated values
        // cc mapping doesn't exist and value was not entered
        // skip entry
      });
      let payload = {
        data: objects
      };

      let url = '/api/sec/employeesync/collectiveContracts/bulk';
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, url);

      return this.axios({
        method: "put",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url,
        data: payload
      }).catch(function (error) {
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('settings.help.errorSavingCollectiveAgreements')
          );
      });
    },

    loadAllowedContracts(storeId, force = false, asArray = false) {
      let view = this;
      let params = {
        storeId: storeId
      };
      return this.$helpers.GetCall('/api/sec/proxy/md/allowedContracts', params)
        .then((response) => {
          Object.values(response.data).forEach(allowedContract => {
            allowedContract.collectiveContractName = view.collectiveContractMap[allowedContract.collectiveContractId].name;
            allowedContract.externalId = "";
            allowedContract.externalId_input = "";
          });
          view.allowedContractArray[storeId] = response.data;
        }).catch((e) => {
        });
    },

    // contract week model nrs
    prepareContractWeekModelNrs() {
      let view = this;
      return view.getContractWeekModelNrMapping()
        .then((mapping) => {
          Object.values(view.allowedContractArray).forEach(storeObj => {
            Object.values(storeObj).forEach(obj => {
              let result = mapping.find(res => {
                return res.allowedContractId === obj.id
              });
              if (result !== undefined) {
                obj.mappingId = result.id;
                obj.externalId = result.externalId;
                obj.externalId_input = result.externalId;
              }
            });
          });
        });
    },
    getContractWeekModelNrMapping() {
      return this.$helpers.GetCall('/api/sec/employeesync/weekModelNr').then((response) => {
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(response.data.data, false));
        });
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    },
    saveContractWeekModelNrs() {
      let view = this;
      let objects = [];

      if (!view.combineSimilarContracts) {
        Object.values(view.allowedContractArray).forEach(acperstore => {
          Object.values(acperstore).forEach(ac => {
            let object = {
              companyId: this.$store.state.companyId,
              allowedContractId: ac.id,
              externalId: ac.externalId_input
            }
            if (ac.mappingId !== undefined) {
              object.id = ac.mappingId;
            }
            if (ac.hasOwnProperty("externalId") && ac.externalId !== ac.externalId_input) {
              // ac mapping exists and has updated values
              objects.push(object);
            } else if (!ac.hasOwnProperty("externalId") && ac.externalId_input !== null && ac.externalId_input !== "") {
              // ac mapping doesn't exist, but value is not empty
              objects.push(object);
            }
            // ac mapping exists, but no updated values
            // ac mapping doesn't exist and value was not entered
            // skip entry
          })
        });
      } else {
        for (const collectiveContractId in view.similarContractWeekModelNrArray) {
          for (const weekWorkDays in view.similarContractWeekModelNrArray[collectiveContractId]) {
            for (const weekTime in view.similarContractWeekModelNrArray[collectiveContractId][weekWorkDays]) {
              let oldVal = view.similarContractWeekModelNrArray[collectiveContractId][weekWorkDays][weekTime];
              let newVal = view.similarContractWeekModelNrArray_input[collectiveContractId][weekWorkDays][weekTime];
              if (oldVal !== newVal && parseInt(newVal).toString() === newVal) {
                Object.values(view.allowedContractArray).forEach(acperstore => {
                  Object.values(acperstore).forEach(ac => {
                    if (ac.collectiveContractId.toString() === collectiveContractId
                      && ac.weekWorkDaysRegular.toString() === weekWorkDays
                      && ac.weekTimeRegular.toString() === weekTime) {

                      ac.externalId_input = newVal;
                      let object = {
                        companyId: this.$store.state.companyId,
                        allowedContractId: ac.id,
                        externalId: ac.externalId_input
                      }
                      if (ac.mappingId !== undefined) {
                        object.id = ac.mappingId;
                      }
                      objects.push(object);
                    }
                  })
                });
              }
            }
          }
        }
      }

      console.log(objects);
      let payload = {
        data: objects
      };

      let url = '/api/sec/employeesync/weekModelNr/bulk';
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, url);

      return this.axios({
        method: "put",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url,
        data: payload
      }).catch(function (error) {
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('settings.help.errorSavingWeekModels')
          );
      });
    },

    // employee sync settings
    prepareEmployeeSyncSettings() {
      let view = this;
      view.employeeSyncSetting = null;
      view.employeeSyncSettingsData = {
        id: -1,
        taxOfficeSerialNumber: "",
        enableExportViaTransferService: false,
        enablePeriodicExport: false,
        employeeChangeMode: 0,
        employeeAutoCreate: false,
        costCenterAutoCreate: false
      };
      view.employeeSyncSettingsData_input = JSON.parse(JSON.stringify(view.employeeSyncSettingsData));
      view.getEmployeeSyncSettings()
        .then((settings) => {
          view.employeeSyncSetting = settings.find(res => {
            return res.softwareId === view.companyData.softwareId
          });
          if (view.employeeSyncSetting === undefined) {
            view.employeeSyncSetting = null;
          }
          view.getEmployeeSyncSettingsData()
            .then((data) => {
              view.employeeSyncSettingsData = JSON.parse(JSON.stringify(data));
              view.employeeSyncSettingsData_input = JSON.parse(JSON.stringify(data));
            }).catch((e) => {

          });
        });
      view.$helpers.GetEmployeeSyncExportProfileArray(true)
        .then((data) => {
          if (data.length > 0) {
            view.exportProfiles = JSON.parse(JSON.stringify(data));
            view.exportProfiles_input = JSON.parse(JSON.stringify(data));
          }
          view.selectedProfileId = view.exportProfiles.find(profile => profile.isDefault)?.id || -1;
        }).catch((e) => {

      });
    },
    getEmployeeSyncSettings() {
      return this.$helpers.GetCall('/api/sec/employeesync/settings').then((response) => {
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(response.data, false));
        });
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    },
    getEmployeeSyncSettingsData() {
      return this.$helpers.GetCall('/api/sec/employeesync/data').then((response) => {
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(response.data, false));
        });
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    },
    saveEmployeeSyncSettingsData() {
      let view = this;

      let method = 'post';
      let url = '/api/sec/employeesync/data';
      if (view.employeeSyncSettingsData.id !== -1) {
        url = url + '/' + view.employeeSyncSettingsData.id;
        method = 'put';
      }
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, url);

      return this.axios({
        method: method,
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url,
        data: view.employeeSyncSettingsData_input
      }).catch(function (error) {
        view.employeeSyncSettingsData_input = JSON.parse(JSON.stringify(view.employeeSyncSettingsData));
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('settings.help.errorSavingGeneralSettings')
          );
      });
    },
    saveEmployeeSyncExportProfiles() {
      let view = this;

      let exportProfilesToSend = JSON.parse(JSON.stringify(view.exportProfiles_input));
      exportProfilesToSend.forEach(profile => {
        if (profile.id < 0) {
          delete profile.id;
        }
      });

      let payload = {
        data: exportProfilesToSend
      };

      let url = '/api/sec/employeesync/exportProfiles/bulk';
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, url);

      return this.axios({
        method: "put",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url,
        data: payload
      }).catch(function (error) {
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('settings.help.errorSavingExportProfiles')
          );
      });
    },
    openAddNewExportProfilePopup() {
      var view = this;

      view.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        componentState: {
          entries: [{
            label: view.$t('settings.help.exportProfileName'),
            key: "label",
            hidden: false,
            type: "text",
            length: 255,
          }],
          positiveButtonLabel: view.$t('settings.help.create'),
          selectCallback: function (entity, event) {
            view.editieren = true;
            let newId = view.exportProfiles_input.length > 0 ? Math.min(0, ...view.exportProfiles_input.map(p => p.id)) - 1 : -1;
            view.exportProfiles_input.push({
              id: newId,
              label: entity.label,
              isDefault: null,
              payslipPassword: 0,
              exportLastNameBlockLetters: true,
              exportLatestContractOnly: true,
              ignoreExternalEmployees: true,
              ignoreHiddenEmployees: true,
              ignoreInactiveEmployees: true,
              exportUnchangedEmployees: true,
              exportChangedEmployees: true,
              exportNewEmployees: true,
            });
            view.selectedProfileId = newId;
          },
          errorCheck: {
          },
        },
        header: view.$t('settings.help.createNewExportProfileHeader'),
        expanded: true,
        centered: true,
      });
    },
    deleteCurrentProfile(profileId) {
      var view = this;

      view.exportProfiles_input = view.exportProfiles_input.filter(p => p.id !== profileId);
      if (view.selectedProfileId === profileId) {
        view.selectedProfileId = view.exportProfiles_input.length > 0 ? view.exportProfiles_input[0].id : -1;
      }

      if (profileId > 0) {
        // try to remove from periodic export times as well
        view.periodicExportTimes = view.periodicExportTimes.filter(t => t.exportProfileId !== profileId);
        view.periodicExportTimes_input = view.periodicExportTimes_input.filter(t => t.exportProfileId !== profileId);

        // also remove backend entry
        this.$helpers.DeleteCall('/api/sec/employeesync/exportProfiles/' + profileId, view.exportProfiles.find(p => p.id === profileId))
        .then((response) => {
          // remove locally
          view.exportProfiles = view.exportProfiles.filter(t => t.id !== profileId);
          view.exportProfiles_input = view.exportProfiles_input.filter(t => t.id !== profileId);
        }).catch((e) => {
            view.$helpers.error(
                view.$t('global.messages.error'),
                view.$t('settings.help.errorDeletingTime')
            );
        });
      }
    },

    // periodic export times
    getPeriodicTimeTypeInputs(type) {
      switch(type) {
        case 1: return [
            { label: this.$t('global.time.sundays'), value: 0 },
            { label: this.$t('global.time.mondays'), value: 1 },
            { label: this.$t('global.time.tuesdays'), value: 2 },
            { label: this.$t('global.time.wednesdays'), value: 3 },
            { label: this.$t('global.time.thursdays'), value: 4 },
            { label: this.$t('global.time.fridays'), value: 5 },
            { label: this.$t('global.time.saturdays'), value: 6 }
        ];
        case 2:
          let items = [];
          for (let i = 0; i <= 30; i++) {
            items.push({ label: this.$t('global.time.dayOfMonth', { day: i + 1 }), value: i});
          }
          items.push({ label: this.$t('global.time.lastDayOfMonth'), value: 31 });
          return items;
        default: return [];
      }
    },
    getPeriodicTimeLabel(time) {
      let view = this;
      let values = view.getPeriodicTimeTypeInputs(time.type);
      let label = "";

      let hours = parseInt(time.hours);
      if (hours > 23) {
        time.hours = 23;
      } else if (hours < 10) {
        time.hours = "0" + hours;
      } else {
        time.hours = hours;
      }

      let minutes = parseInt(time.minutes);
      if (minutes > 59) {
        time.minutes = 59;
      } else if (minutes < 10) {
        time.minutes = "0" + minutes;
      } else {
        time.minutes = minutes;
      }

      switch (time.type) {
        case 0: return time.hours + ":" + time.minutes;
        case 1: label = values[time.dayOfWeek].label; break;
        case 2: label = values[time.dayOfMonth].label; break;
      }
        return this.$t('global.time.labelAtTime', {
            label,
            hours: time.hours,
            minutes: time.minutes
        });
    },
    preparePeriodicExportTimes() {
      let view = this;

      view.periodicExportTimes = [];
      view.periodicExportTimes_input = [];

      this.loadPeriodicExportTimes()
      .then((response) => {
        view.periodicExportTimes = JSON.parse(JSON.stringify(response));
        view.periodicExportTimes_input = JSON.parse(JSON.stringify(response));
      });
    },
    loadPeriodicExportTimes() {
      return this.$helpers.GetCall('/api/sec/employeesync/periodicExportSettings').then((response) => {
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(response.data, false));
        });
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    },
    savePeriodicExportTimes() {
      let view = this;

      let payload = {
        data: view.periodicExportTimes_input
      };

      let url = '/api/sec/employeesync/periodicExportSettings/bulk';
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, url);

      return this.axios({
        method: "put",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url,
        data: payload
      }).catch(function (error) {
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('settings.help.errorSavingPeriodicExportTimes')
          );
      });
    },
    deletePeriodicExportTime(index) {
      let view = this;
      let elementAtIndex = view.periodicExportTimes_input[index];

      // remove remote if it has id
      if (elementAtIndex.id !== undefined) {
        console.log("element had id");
        this.$helpers.DeleteCall('/api/sec/employeesync/periodicExportSettings/' + elementAtIndex.id, elementAtIndex)
        .then((response) => {
          let idx = view.periodicExportTimes.indexOf(view.periodicExportTimes.find(time => time.id === elementAtIndex.id));
          // remove locally
          view.periodicExportTimes.splice(idx, 1);
          view.periodicExportTimes_input.splice(index, 1);
        }).catch((e) => {
            view.$helpers.error(
                view.$t('global.messages.error'),
                view.$t('settings.help.errorDeletingTime')
            );
        });
      } else {
        console.log("element did not have id");
        // remove from input array only
        view.periodicExportTimes_input.splice(index, 1);
      }
    },

    // employee sync fields & field settings
    getEmployeeSyncFields() {
      let view = this;

      let method = 'get';
      let baseUrl = '/api/sec/employeesync/fields';
      let url = baseUrl;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseUrl);

      this.axios({
        method: method,
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then((fieldsResponse) => {
        this.getEmployeeSyncFieldSettings()
          .then((settingsResponse) => {
            if (settingsResponse !== null && settingsResponse.data !== null && settingsResponse.data.length > 0) {
              let localSettings = [];
              Object.values(settingsResponse.data).forEach((element) => {
                localSettings[element.fieldId] = element;
              });
              this.getEmployeeSyncFieldSettingDefaults()
                .then((response) => {
                  let newField = false;
                  Object.values(response.data).forEach((element) => {
                    if (localSettings[element.fieldId] !== undefined) {
                      localSettings[element.fieldId].defaultName = element.fieldInternalName;
                    } else {
                      newField = true;
                      localSettings[element.fieldId] = element;
                      localSettings[element.fieldId].defaultName = element.fieldInternalName;
                    }
                  });
                  view.loadSettingsResponse(fieldsResponse, localSettings);
                  if (newField) {
                    view.saveEmployeeSyncFieldSettings();
                  }
                });
            } else {
              this.getEmployeeSyncFieldSettingDefaults()
                .then((response) => {
                  let localSettings = [];
                  Object.values(response.data).forEach((element) => {
                    localSettings[element.fieldId] = element;
                    localSettings[element.fieldId].defaultName = element.fieldInternalName;
                  });
                  view.loadSettingsResponse(fieldsResponse, localSettings);
                });
            }
          });
      }).catch(function (error) {
        console.log(error);
        view.$helpers.error(
            view.$t('global.messages.error'),
            view.$t('settings.help.errorLoadingEmpSyncFields')
        );
      });
    },
    getEmployeeSyncFieldSettings() {
      let view = this;

      let method = 'get';
      let baseUrl = '/api/sec/employeesync/fields/settings';
      let url = baseUrl;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseUrl);

      return this.axios({
        method: method,
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).catch(function (error) {
        console.log(error);
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('settings.help.errorLoadingEmpSyncFieldSettings')
          );
      });
    },
    getEmployeeSyncFieldSettingDefaults() {
      let view = this;

      let method = 'get';
      let baseUrl = '/api/sec/employeesync/fields/settings/default';
      let url = baseUrl;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseUrl);
      url = this.$helpers.appendParam("softwareId", view.companyData.softwareId, url, baseUrl);

      return this.axios({
        method: method,
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).catch(function (error) {
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('settings.help.errorLoadingEmpSyncFieldDefaultSettings')
          );
      });
    },
    resetEmployeeSyncFields() {
      let view = this;

      let method = 'post';
      let baseUrl = '/api/sec/employeesync/fields/settings/reset';
      let url = baseUrl;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseUrl);
      url = this.$helpers.appendParam("softwareId", view.companyData.softwareId, url, baseUrl);

      return this.axios({
        method: method,
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).catch(function (error) {
        view.$helpers.error(
          view.$t('global.messages.error'),
          view.$t('settings.help.errorLoadingEmpSyncFieldDefaultSettings')
        );
      });
    },
    loadSettingsResponse(response, localSettings) {
      Object.values(response.data).forEach((field) => {
        // console.log("field", field);
        if (field.fieldName === "payslipPassword" && !this.employeeSyncSetting.payslipPassword) {
          localSettings[field.id].disabled = true;
        } else if (field.fieldName === "taxOfficeSerialNumber" && !this.employeeSyncSetting.taxOfficeSerialNumber) {
          localSettings[field.id].disabled = true;
        } else if (field.fieldName === "municipalitySerialNumber" && !this.employeeSyncSetting.municipalitySerialNumber) {
          localSettings[field.id].disabled = true;
        } else if (field.fieldName === "collectiveContractExternalId" && !this.employeeSyncSetting.collectiveContracts) {
          localSettings[field.id].disabled = true;
        } else if ((field.fieldName === "wageGroup" || field.fieldName === "wageGroupSwap") && !this.employeeSyncSetting.wageGroups) {
          localSettings[field.id].disabled = true;
        } else {
          localSettings[field.id].disabled = false;
        }
      });
      localSettings.sort((a, b) => (a.fieldOrder > b.fieldOrder) ? 1 : ((b.fieldOrder > a.fieldOrder) ? -1 : 0))
      this.employeeSyncFieldSettings = localSettings;
    },
    updateFieldOrder(from, to) {
      let view = this;

      Object.values(view.employeeSyncFieldSettings).forEach((element) => {
        if (element.fieldOrder === from) {
          //console.log(element.fieldOrder + " to " + to);
          element.fieldOrder = to;
        } else {
          if (from < to && element.fieldOrder > from && element.fieldOrder <= to) {
            //console.log(element.fieldOrder + " to " + (element.fieldOrder - 1));
            element.fieldOrder -= 1;
          } else if (from > to && element.fieldOrder < from && element.fieldOrder >= to) {
            //console.log(element.fieldOrder + " to " + (element.fieldOrder + 1));
            element.fieldOrder += 1;
          }
        }
      });
    },
    saveEmployeeSyncFieldSettings() {
      let view = this;

      if (!view.employeeSyncFieldSettingsDuplicates()) {
        let method = 'post';
        let url = '/api/sec/employeesync/fields/settings/all';
        url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, url);

        let payload = {
          'data': view.employeeSyncFieldSettings
        }

        return this.axios({
          method: method,
          headers: {
            'AUTHORIZATION': "Bearer " + this.$store.state.jwt
          },
          url: url,
          data: payload
        }).catch(function (error) {
            view.$helpers.error(
                view.$t('global.messages.error'),
                view.$t('settings.help.errorSavingEmpSyncFields')
            );
        });
      } else {
          view.$helpers.error(
              view.$t('settings.help.duplicateErrorTitle'),
              view.$t('settings.help.duplicateErrorMessage')
          );
      }
    },
    employeeSyncFieldSettingsDuplicates() {
      let view = this;
      var valueArr = view.employeeSyncFieldSettings.map(function (item) {
        return item.fieldName
      });
      return valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) !== idx
      });
    },

    // wage groups
    prepareWageGroups() {
      let view = this;
      view.wageGroup = {
        id: -1,
        fullyInsuredEmployee: "",
        fullyInsuredWorker: "",
        marginallyEmployedEmployee: "",
        marginallyEmployedWorker: "",
        apprenticeEmployee: "",
        apprenticeWorker: "",
        independentContractorEmployee: "",
        independentContractorWorker: "",
        marginallyEmployedIndependentContractorEmployee: "",
        marginallyEmployedIndependentContractorWorker: "",
      };
      view.wageGroup_input = JSON.parse(JSON.stringify(view.wageGroup));
      view.getWageGroups()
        .then((data) => {
          view.wageGroup = data;
          view.wageGroup_input = data;
        }).catch((e) => {

      });
    },
    getWageGroups() {
      return this.$helpers.GetCall('/api/sec/employeesync/wageGroup').then((response) => {
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(response.data, false));
        });
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    },
    saveWageGroups() {
      let view = this;

      let method = 'post';
      let url = '/api/sec/employeesync/wageGroup';
      if (view.wageGroup.id !== -1) {
        url = url + '/' + view.wageGroup.id;
        method = 'put';
      }
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, url);

      return this.axios({
        method: method,
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url,
        data: view.wageGroup_input
      }).catch(function (error) {
        view.wageGroup_input = view.wageGroup;
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('settings.help.errorSavingTariffGroups')
          );
      });
    },

    // valuation models
    prepareValuationModels() {
      let view = this;
      view.valuationModel = {
        id: -1,
        allInModels: "",
        accPeriodPriority1Models: "",
        accPeriodPriority2Models: "",
        accPeriodPriority3Models: "",
      };
      view.valuationModel_input = JSON.parse(JSON.stringify(view.valuationModel));
      view.getValuationModels()
        .then((data) => {
          console.log(data);
          view.valuationModel = data;
          view.valuationModel_input = data;
        }).catch((e) => {

      });
    },
    getValuationModels() {
      return this.$helpers.GetCall('/api/sec/employeesync/valuationModel').then((response) => {
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(response.data, false));
        });
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    },
    saveValuationModels() {
      let view = this;

      let method = 'post';
      let url = '/api/sec/employeesync/valuationModel';
      if (view.valuationModel.id !== -1) {
        url = url + '/' + view.valuationModel.id;
        method = 'put';
      }
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, url);

      return this.axios({
        method: method,
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url,
        data: view.valuationModel_input
      }).catch(function (error) {
        view.valuationModel_input = view.valuationModel;
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('settings.help.errorSavingRatingModels')
          );
      });
    },

    // bmd downloads
    // import
    downloadImportBmdInterface() {
      let view = this;

        let resourceName = "dienstnehmer_generieren.zip";
      view.loadResourceFile("bmd", resourceName)
      .then((resp) => {
        let content = view.$helpers.convertToUInt8(atob(resp.data.content));
        view.$helpers.forceFileDownload(content, view.$t('settings.help.generateEmployeesZip')); //resp.data.name, true);
      });
    },
    openSvnrCheckMakroPopup() {
      var view = this;

        view.$helpers.OpenPopup({
            elRelative: null,
            type: 'datafill',
            componentState: {
                description: view.$t('settings.help.svnrMacroDescription'),
                entries: [],
                positiveButtonLabel: view.$t('settings.help.svnrMacroDownloadButton'),
                selectCallback: function (result, event) {
                    view.downloadSvnrCheckMakro();
                },
                errorCheck: {},
            },
            header: view.$t('settings.help.svnrMacroHeader'),
            expanded: true,
            centered: true,
        });
    },
    downloadSvnrCheckMakro() {
      let view = this;

        let resourceName = "makro_dn_import_svnr_check.txt";
      view.loadResourceFile("bmd", resourceName)
      .then((resp) => {
        let content = view.$helpers.convertToUInt8(atob(resp.data.content));
        view.$helpers.forceFileDownload(content, view.$t('settings.help.svnrMacroFilenameTxt')); //resp.data.name, true);
      });
    },

    // export
    downloadExportBmdInterface() {
      let view = this;

        let resourceName = "dienstnehmer_exportieren.zip";
      view.loadResourceFile("bmd", resourceName)
        .then((resp) => {
          let content = view.$helpers.convertToUInt8(atob(resp.data.content));
          view.$helpers.forceFileDownload(content, view.$t('settings.help.employeeExportFilenameZip')); //resp.data.name, true);
        });
    },
    openValidFromMakroPopup() {
      var view = this;

      let entries = [
        {
            label: view.$t('settings.help.macroNumber'),
          key: "macroNumber",
          hidden: false,
          type: "text",
          value: ""
        },
        {
            label: view.$t('settings.help.formulaText'),
          key: "formulaText",
          hidden: false,
          type: "text",
          readonly: true,
          copyButton: true,
            copyButtonTooltip: view.$t('settings.help.copyFormulaTooltip'),
          value: "",
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let macroNumber = datafill.entries.find((i) => i.key === "macroNumber").value;
            entryBeforeUpdate.value = "FUNCTION[\"EXECUTEMACRO\";" + macroNumber + "; FUNCTION[\"CONCAT\";FUNCTION[\"CONCAT\";\"pFirmennr=\"; FIELD[\"MCA_PSJ_FIRMENNR\"] ] ; FUNCTION[\"CONCAT\";FUNCTION[\"CONCAT\";\";pMaid=\"; FIELD[\"MCA_PSJ_MITARBEITERID\"] ] ; FUNCTION[\"CONCAT\";\";pDvnr=\"; FIELD[\"MCA_DVH_DIENSTVLFDNR\"] ] ] ] ] §§T1S1E270L0/T3S25E40L1/T4S42E269L1/T1S42E268L2/T4S60E120L3/T1S60E119L4/T3S78E90L5/T4S92E118L5/T2S92E117L6/T4S122E267L3/T1S122E266L4/T4S140E202L5/T1S140E201L6/T3S158E167L7/T4S169E200L7/T2S169E199L8/T4S204E265L5/T1S204E264L6/T3S222E231L7/T4S233E263L7/T2S233E262L8/";
            return entryBeforeUpdate;
          },
        },
      ]

      view.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        remainAfterSelect: true,
        componentState: {
            description: view.$t('settings.help.validFromMacroDescription'),
            entries: entries,
            positiveButtonLabel: view.$t('settings.help.validFromMacroDownloadButton'),
            selectCallback: function (result, event) {
            view.downloadValidFromMakro();
          },
          errorCheck: {
          },
        },
          header: view.$t('settings.help.validFromMacroHeader'),
        expanded: true,
        centered: true,
      });
    },
    downloadValidFromMakro() {
      let view = this;

        let resourceName = "gueltig_ab_makro_import.xml";
      view.loadResourceFile("bmd", resourceName)
      .then((resp) => {
        let content = view.$helpers.convertToUInt8(atob(resp.data.content));
        view.$helpers.forceFileDownload(content, view.$t('settings.help.validFromMacroFilenameXml')); //resp.data.name, true);
      });
    },
    openWageFormulaPopup() {
      var view = this;

      let entries = [
        {
          label: view.$t('settings.help.formulaText'),
          key: "formulaText",
          hidden: false,
          type: "text",
          copyButton: true,
          copyButtonTooltip: view.$t('settings.help.copyFormulaTooltip'),
          readonly: true,
          value: "FUNCTION[\"3949501\";\"1474975078000300700,-1,2,-1\"] §§T1S1E50L0/T6S20E49L1/",
        },
      ]

      view.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        componentState: {
            description: view.$t('settings.help.kvWageFormulaDescription'),
            entries: entries,
            positiveButtonLabel: view.$t('global.ui.close'),
            selectCallback: function (result, event) {
          },
          errorCheck: {
          },
        },
          header: view.$t('settings.help.kvWageFormulaHeader'),
        expanded: true,
        centered: true,
      });
    },

    // stapel import
    openBmdEditelFolderStructurePopup() {
      var view = this;

      view.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        componentState: {
            description: view.$t('settings.help.editelFolderDescription', { company: view.companyName }),
            entries: [],
            positiveButtonLabel: view.$t('settings.help.editelFolderDownloadButton'),
          selectCallback: function (result, event) {
            let resourceName = "editel_folder_structure.zip";
            view.loadResourceFile("bmd", view.$t('settings.help.editelFolderZipName'))
              .then((resp) => {
                let content = view.$helpers.convertToUInt8(atob(resp.data.content));
                view.$helpers.forceFileDownload(content, view.$t('settings.help.editelFolderZipName'));
              });
          },
          errorCheck: {
          },
        },
        header: view.$t('settings.help.editelFolderHeader'),
        expanded: true,
        centered: true,
      });
    },
    openEmployeeImportStapelPopup() {
      var view = this;

      view.$helpers.OpenPopup({
        elRelative: null,
        remainAfterSelect: true,
        type: 'datafill',
        componentState: {
            description: view.$t('settings.help.employeeImportMacroDescription'),
            entries: [],
            positiveButtonLabel: view.$t('settings.help.employeeImportMacroDownload'),
            negativeButtonLabel: view.$t('settings.help.employeeImportStapelDownload'),
            selectCallback: function (result, event) {
            view.downloadEmployeeImportMacro();
          },
          deleteCallback: function (result, event) {
            view.downloadEmployeeImportStapel();
          },
          errorCheck: {
          },
        },
        header: view.$t('settings.help.employeeImportMacroHeader'),
        expanded: true,
        centered: true,
      });
    },
    downloadEmployeeImportMacro() {
      let view = this;

      let resourceName = "BMD__FOR_FORMEL_749442349778069_dn_import.XML";
      view.loadResourceFile("bmd", resourceName)
      .then((resp) => {
        let content = view.$helpers.convertToUInt8(atob(resp.data.content));
        view.$helpers.forceFileDownload(content, resourceName); //resp.data.name, true);
      });
    },
    downloadEmployeeImportStapel() {
      let view = this;

      let resourceName = "employee_import_stapel.zip";
      view.loadResourceFile("bmd", resourceName)
      .then((resp) => {
        let content = view.$helpers.convertToUInt8(atob(resp.data.content));
        view.$helpers.forceFileDownload(content, resourceName); //resp.data.name, true);
      });
    },
    openEmployeeExportStapelPopup() {
      var view = this;

      view.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        remainAfterSelect: true,
        componentState: {
            description: view.$t('settings.help.employeeExportStapelDescription'),
            entries: [],
            positiveButtonLabel: view.$t('settings.help.employeeExportStapelDownload'),
            selectCallback: function (result, event) {
            view.downloadEmployeeExportStapel();
          },
          errorCheck: {
          },
        },
        header: view.$t('settings.help.employeeExportStapelHeader'),
        expanded: true,
        centered: true,
      });
    },
    downloadEmployeeExportStapel() {
      let view = this;

      let resourceName = "employee_export_stapel.zip";
      view.loadResourceFile("bmd", resourceName)
      .then((resp) => {
        let content = view.$helpers.convertToUInt8(atob(resp.data.content));
        view.$helpers.forceFileDownload(content, resourceName); //resp.data.name, true);
      });
    },

    // hidden for now
    openBmdLoginDataPopup() {
      var view = this;

        let entries = [
            {
                label: view.$t('settings.help.dbLabel'),
                key: "db",
                hidden: false,
                type: "text"
            },
            {
                label: view.$t('settings.help.userLabel'),
                key: "user",
                hidden: false,
                type: "text"
            },
            {
                label: view.$t('settings.help.passwordLabel'),
                key: "pass1",
                hidden: false,
                type: "password"
            },
            {
                label: view.$t('settings.help.passwordRepeatLabel'),
                key: "pass2",
                hidden: false,
                type: "password"
            },
        ];

      view.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        componentState: {
            description: view.$t('settings.help.bmdCredentialsDescription'),
            entries: entries,
            positiveButtonLabel: view.$t('settings.help.generateAndDownloadDocument'),
            selectCallback: function (result, event) {
            let file = "Datenbank=" + result.db + "\r\n" +
                "Benutzer=" + result.user + "\r\n" +
                "Passwort=" + result.pass1;
            view.$helpers.forceFileDownload(file, view.$t('settings.help.credentialsFileName'));
          },
          errorCheck: {
            pass1: (entries) => {
              if (entries.pass1 !== '' && entries.pass2 !== '' && entries.pass1 !== entries.pass2)
                return {
                  key: "pass1",
                  type: "error",
                    text: view.$t('settings.help.passwordMismatch'),
                };
              else return null;
            },
            pass2: (entries) => {
              if (entries.pass1 !== '' && entries.pass2 !== '' && entries.pass1 !== entries.pass2)
                return {
                  key: "pass1",
                  type: "error",
                    text: view.$t('settings.help.passwordMismatch'),
                };
              else return null;
            },
          },
        },
        header: view.$t('settings.help.bmdCredentialsHeader'),
        expanded: true,
        centered: true,
      });
    },
    openBmdImportScriptPopup() {
      var view = this;

        let entries = [
            {
                label: view.$t('settings.help.bmdCompanyNumber'),
                key: "externalCompanyId",
                hidden: false,
                type: "text",
                value: view.bmdId,
                disabled: true
            },
            {
                label: view.$t('settings.help.bmdInstallationFolder'),
                key: "bmdntcs",
                hidden: false,
                type: "text",
                placeholder: view.$t('settings.help.bmdInstallationFolderPlaceholder'),
                forceLabel: true
            },
            {
                label: view.$t('settings.help.bmdImportFunction'),
                key: "bmd_function",
                hidden: false,
                type: "dropdownsearch",
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: "",
                    items: view.bmdImportScriptFunctions,
                    selectMultiple: false,
                    selectedItems: [],
                    selectedItem: null,
                    onceSelected: function ($event, item, searchbar) {},
                    styleLight: true,
                    placeholder: view.$t('settings.help.pleaseSelect'),
                },
            },
            {
                label: view.$t('settings.help.interfaceLabel'),
                key: "bmd_interface",
                hidden: false,
                type: "text",
                placeholder: view.$t('settings.help.interfacePlaceholder'),
                forceLabel: true
            },
            {
                label: view.$t('settings.help.editelBaseFolder'),
                key: "base_folder",
                hidden: false,
                type: "text",
                placeholder: view.$t('settings.help.editelBaseFolderPlaceholder'),
                forceLabel: true
            },
            {
                label: view.$t('settings.help.companyFolderName'),
                key: "company_name",
                hidden: false,
                type: "text",
                value: view.companyName,
                placeholder: view.companyName,
                forceLabel: true
            },
        ];

      view.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        componentState: {
            description: view.$t('settings.help.bmdImportScriptDescription'),
            entries: entries,
            positiveButtonLabel: view.$t('settings.help.generateImportScript'),
            selectCallback: function (result, event) {
            view.createBmdImportScriptFile(result)
            .then((script) => {
              let content = view.$helpers.convertToUInt8(script);
              view.$helpers.forceFileDownload(content, "import_" + view.bmdImportScriptFunctionFolder[result.bmd_function] + ".bat");
            });
          },
            errorCheck: {
                bmdntcs: (entries) => {
                    if (entries.bmdntcs === '' || entries.bmdntcs === undefined)
                        return {
                            key: "bmdntcs",
                            type: "error",
                            text: view.$t('settings.help.errBmdInstallationFolderRequired'),
                        };
                    else return null;
                },
                bmd_function: (entries) => {
                    if (entries.bmd_function === '' || entries.bmd_function === null)
                        return {
                            key: "bmd_function",
                            type: "error",
                            text: view.$t('settings.help.errSelectImportFunction'),
                        };
                    else return null;
                },
                bmd_interface: (entries) => {
                    if (entries.bmd_interface === '' || entries.bmd_interface === undefined)
                        return {
                            key: "bmd_interface",
                            type: "error",
                            text: view.$t('settings.help.errInterfaceNameRequired'),
                        };
                    else return null;
                },
                base_folder: (entries) => {
                    if (entries.base_folder === '' || entries.base_folder === undefined)
                        return {
                            key: "base_folder",
                            type: "error",
                            text: view.$t('settings.help.errEditelBaseFolderRequired'),
                        };
                    else return null;
                },
                company_name: (entries) => {
                    if (entries.company_name === '' || entries.company_name === undefined)
                        return {
                            key: "company_name",
                            type: "error",
                            text: view.$t('settings.help.errCompanyFolderRequired'),
                        };
                    else return null;
                },
            },
        },
        header: view.$t('settings.help.bmdImportScriptHeader'),
        expanded: true,
        centered: true,
      });
    },
    createBmdImportScriptFile(result) {
      let view = this;

      return view.loadResourceFile("bmd", "import_script_template.txt")
      .then((resp) => {
        let content = atob(resp.data.content);
        content = content.replaceAll("[[externalCompanyId]]", result.externalCompanyId);
        content = content.replaceAll("[[bmdntcs]]", "\"" + result.bmdntcs + "\\BMDNTCS.exe\"");
        content = content.replaceAll("[[bmd_function]]", result.bmd_function);
        content = content.replaceAll("[[bmd_interface]]", result.bmd_interface);
        content = content.replaceAll("[[base_folder]]", "\"" + result.base_folder + "\"");
        content = content.replaceAll("[[company_name]]", "\"" + result.company_name + "\"");
        content = content.replaceAll("[[bmd_function_folder]]", this.bmdImportScriptFunctionFolder[result.bmd_function]);
        return content;
      });
    },

    loadResourceFile(resourceType, resourceName) {
      let url = "/api/sec/resource";
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, "/api/sec/resource");
      url = this.$helpers.appendParam("resourceType", resourceType, url, "/api/sec/resource");
      url = this.$helpers.appendParam("resourceName", resourceName, url, "/api/sec/resource");
      return this.axios({
        method: "get",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
      });
    },

    // CSV download
    openDownloadCsvPopup() {
      var view = this;

      let items = view.exportProfiles.map((profile) => {
        return {
          value: profile.id,
          label: profile.label,
        };
      });
      let selectedItem = items[0] || null;

      view.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        componentState: {
          entries: [
            {
              label: view.$t('settings.help.exportProfileLabel'),
              key: "exportProfileId",
              hidden: false,
              type: "dropdownsearch",
              dropdownSearchState: {
                items: items,
                selectMultiple: false,
                selectedItem: selectedItem,
                onceSelected: function ($event, item, searchbar) {},
                styleLight: true,
                placeholder: view.$t('settings.help.pleaseSelect'),
              },
            },
            {
                label: view.$t('settings.help.useForDeltaCalculation'),
              key: "useForDeltaCalculation",
              hidden: false,
              type: "bool",
              value: false,
            }
          ],
            positiveButtonLabel: view.$t('settings.help.downloadCsvExport'),
          selectCallback: function (entity, event) {
            view.downloadCSV(entity);
          },
          errorCheck: {
          },
        },
        header: view.$t('settings.help.csvExportHeader'),
        expanded: true,
        centered: true,
      });
    },
    downloadCSV(entity) {
      let view = this;
      view.loadingDownload = true;

      let url = '/api/sec/employeesync/getexport';
      let baseurl = url;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);
      url = this.$helpers.appendParam("softwareId", view.companyData.softwareId, url, baseurl);
      url = this.$helpers.appendParam("exportProfileId", entity.exportProfileId, url, baseurl);
      url = this.$helpers.appendParam("useForDeltaCalculation", entity.useForDeltaCalculation ? 1 : 0, url, baseurl);
      // url = this.$helpers.appendParam("remoteIds", [407,408], url, baseurl);

      this.axios({
        method: "get",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then((response) => {
        let csv = response.data.data;
        let job = response.data.job;

        job.jobStarted = job.jobStarted != null ? view.$helpers.convertUTCDateStringTZ(job.jobStarted, 'DD.MM.YYYY HH:mm:ss') : null;
        job.jobEnded = job.jobEnded != null ? view.$helpers.convertUTCDateStringTZ(job.jobEnded, 'DD.MM.YYYY HH:mm:ss') : null;
        job.jobFailed = job.jobFailed != null ? view.$helpers.convertUTCDateStringTZ(job.jobFailed, 'DD.MM.YYYY HH:mm:ss') : null;
        view.setExportStatus(job);
        view.loadAuthuser(job.authuserId);

        view.exportJobs.push(job);

        //console.log(view.$helpers.b64DecodeUnicode(csv));
        view.$helpers.forceFileDownload(view.$helpers.b64DecodeUnicode(csv), "Export.csv");
        view.loadingDownload = false;
      }).catch((e) => {
        view.loadingDownload = false;
        view.$helpers.error(
          view.$t('global.messages.error'),
          view.$t('settings.help.createExportError')
        );
      });
    },
    downloadCSVFromExportJob(csv) {
      let view = this;
      view.$helpers.forceFileDownload(csv, "Export.csv");
    },
    // CSV exports
    openExportCsvPopup() {
      var view = this;

      let items = view.exportProfiles.map((profile) => {
        return {
          value: profile.id,
          label: profile.label,
        };
      });
      let selectedItem = items[0] || null;

      view.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        componentState: {
          entries: [
            {
                label: view.$t('settings.help.exportProfileLabel'),
              key: "exportProfileId",
              hidden: false,
              type: "dropdownsearch",
              dropdownSearchState: {
                items: items,
                selectMultiple: false,
                selectedItem: selectedItem,
                onceSelected: function ($event, item, searchbar) {},
                styleLight: true,
                placeholder: view.$t('settings.help.pleaseSelect'),
              },
            }
          ],
            positiveButtonLabel: view.$t('settings.help.triggerExport'),
          selectCallback: function (entity, event) {
            view.exportCSV(entity);
          },
          errorCheck: {
          },
        },
        header: view.$t('settings.help.triggerLvExportHeader'),
        expanded: true,
        centered: true,
      });
    },
    exportCSV(entity) {
      let view = this;
      view.loadingExport = true;

      let url = '/api/sec/employeesync/export';
      let baseurl = url;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);
      url = this.$helpers.appendParam("softwareId", view.companyData.softwareId, url, baseurl);
      url = this.$helpers.appendParam("exportProfileId", entity.exportProfileId, url, baseurl);

      this.axios({
        method: "get",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then((response) => {
        view.loadingExport = false;
          view.$helpers.info(
              view.$t('global.messages.info'),
              view.$t('settings.help.exportLvToolSuccess')
          );
      }).catch((e) => {
        view.loadingExport = false;
        view.$helpers.error(
          view.$t('global.messages.error'),
          view.$t('settings.help.createExportError')
        );
      });
    },
    loadExportJobs() {
      let view = this;

      let url = '/api/sec/employeesync/exports';
      let baseurl = url;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);

      this.axios({
        method: "get",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then((response) => {
        view.exportJobs = response.data;

        Object.values(view.exportJobs).forEach((elem) => {
          elem.jobStarted = elem.jobStarted != null ? view.$helpers.convertUTCDateStringTZ(elem.jobStarted, 'DD.MM.YYYY HH:mm:ss') : null;
          elem.jobEnded = elem.jobEnded != null ? view.$helpers.convertUTCDateStringTZ(elem.jobEnded, 'DD.MM.YYYY HH:mm:ss') : null;
          elem.jobFailed = elem.jobFailed != null ? view.$helpers.convertUTCDateStringTZ(elem.jobFailed, 'DD.MM.YYYY HH:mm:ss') : null;
          view.setExportStatus(elem);
          view.loadAuthuser(elem.authuserId);
        });
      }).catch((e) => {

      });
    },
    setExportStatus(exportJob) {
      exportJob.status = "DONE"
      if (!exportJob.jobEnded) {
        exportJob.status = "FAILED";
      } else if (exportJob.employeeWarnings) {
        let jsonWarnings = JSON.parse(exportJob.employeeWarnings);

        let otherWarnings = 0;
        let ignorableWarnings = 0;
        let hardIgnorableWarnings = 0;

        Object.values(jsonWarnings).forEach(empWarnings => {
          Object.values(empWarnings.warnings).forEach(warning => {
            if (this.ignorableWarnings.includes(warning)) {
              ignorableWarnings++;
            } else if (this.hardIgnorableWarnings.includes(warning)) {
              hardIgnorableWarnings++;
            } else {
              otherWarnings++;
            }
          })
        });

        if (otherWarnings > 0) {
          exportJob.status = "WARNING";
        } else if (ignorableWarnings > 0) {
          exportJob.status = "IGNORE-WARNING";
        } else if (hardIgnorableWarnings > 0) {
          exportJob.status = "DONE"; // maybe add some other status. really ignore those for now
        }
      }
    },
    getStorelessEmployeeWarnings(exportJob) {
      let jsonWarnings = JSON.parse(exportJob.employeeWarnings);
      return Object.values(jsonWarnings).filter(empWarnings => Object.values(empWarnings.warnings).includes("Employee skipped: No StoreId"));
    },
    getInactiveEmployeeWarnings(exportJob) {
      let jsonWarnings = JSON.parse(exportJob.employeeWarnings);
      return Object.values(jsonWarnings).filter(empWarnings => Object.values(empWarnings.warnings).includes("Employee skipped: Inactive Employee"));
    },
    getExternalEmployeeWarnings(exportJob) {
      let jsonWarnings = JSON.parse(exportJob.employeeWarnings);
      return Object.values(jsonWarnings).filter(empWarnings => Object.values(empWarnings.warnings).includes("Employee skipped: External Employee"));
    },
    getHiddenEmployeeWarnings(exportJob) {
      let jsonWarnings = JSON.parse(exportJob.employeeWarnings);
      return Object.values(jsonWarnings).filter(empWarnings => Object.values(empWarnings.warnings).includes("Employee skipped: Hidden Employee"));
    },
    getOtherWarningsTable(exportJob) {
      let jsonWarnings = JSON.parse(exportJob.employeeWarnings);
      let table = [];

      Object.values(jsonWarnings).forEach(empWarnings => {
        Object.values(empWarnings.warnings).forEach(warning => {
          if (!this.ignorableWarnings.includes(warning) && !this.hardIgnorableWarnings.includes(warning)) {
            if (!table.find(w => w.name === warning)) {
              table.push({name: warning, emps: []});
            }
            if (!table.find(w => w.name === warning).emps.includes(empWarnings.employeeId)) {
              table.find(w => w.name === warning).emps.push(empWarnings.employeeId);
            }
          }
        })
      });
      return table;
    },

    jobCreated: function (e) {
      let view = this;
      setTimeout(function () {
        console.log("JOB CREATED EVENT GOT TRIGGERED");
        view.exportJobs.push(e.data.job);
      }, 50);
    },
    jobStarted: function (e) {
      let view = this;
      setTimeout(function () {
        console.log("JOB STARTED EVENT GOT TRIGGERED");
        let job = view.exportJobs.find(j => j.id === e.data.job.id);
        if (job) {
          job.jobStarted = view.$helpers.convertUTCDateStringTZ(e.data.job.jobStarted, 'DD.MM.YYYY HH:mm:ss');
          view.$forceUpdate();
        }
      }, 100);
    },
    jobEnded: function (e) {
      let view = this;
      setTimeout(function () {
        console.log("JOB ENDED EVENT GOT TRIGGERED");
        let job = view.exportJobs.find(j => j.id === e.data.job.id);
        if (job) {
          job.jobEnded = view.$helpers.convertUTCDateStringTZ(e.data.job.jobEnded, 'DD.MM.YYYY HH:mm:ss');
          job.exportCSV = e.data.job.exportCSV;
          job.employeeWarnings = e.data.job.employeeWarnings;
          view.setExportStatus(job);
          view.$forceUpdate();
        }
      }, 200);
    },
    jobFailed: function (e) {
      let view = this;
      setTimeout(function () {
        console.log("JOB FAILED EVENT GOT TRIGGERED");
        let job = view.exportJobs.find(j => j.id === e.data.job.id);
        if (job) {
          job.jobFailed = view.$helpers.convertUTCDateStringTZ(e.data.job.jobFailed, 'DD.MM.YYYY HH:mm:ss');
          view.$forceUpdate();
        }
      }, 200);
    },

    // helper
    getPayslipPasswordSettingByKey(key) {
      let label = "";
      this.payslipPasswordSettings.forEach(function (item, index) {
        if (item.value === key) {
          label = item.label;
        }
      });
      return label;
    },
    updateCompanySettings: function (response) {
      let view = this;
      view.hasAccessRights = true;

      if (response.data.length == 1) {
        view.companyData = response.data[0];

        view.internalId = view.companyData.id;
        view.companyName = view.companyData.name;
        view.companyDescription = view.companyData.description;
        view.bmdId = view.companyData.bmdId;
        view.dpwId = view.companyData.dpwId;
        view.companyNumber = view.companyData.companyNumber;

        view.inputBmdId = view.bmdId;
        view.inputDpwId = view.dpwId;
        view.inputCompanyNumber = view.companyNumber;
      }
    },
    openResetDropdown() {
      var view = this;
      // var target = $event.currentTarget;

      view.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        componentState: {
            description: view.$t('settings.help.resetToDefaultsDescription'),
          entries: [],
          selectCallback: function () {
            view.employeeSyncFieldSettings = [];
            view.resetEmployeeSyncFields()
              .then((response) => {
                view.getEmployeeSyncFields();
              });
          }
        },
        header: view.$t('settings.help.resetToDefaultsHeader'),
        expanded: true,
        centered: true,
      });
    },
    printAssoArray(array) {
      let string = "";
      for (const index in array) {
        if (string !== "") {
          string += ", ";
        }
        string += index;
      }
      return string;
    },
    openAcDetailsModal() {
      this.$refs["modal-ac-details"].show();
    },
    closeAcDetailsModal() {
      this.$refs["modal-ac-details"].hide();
    },
    openExportJobStatusModal() {
      this.$refs["modal-exportjob-status"].show();
    },
    closeExportJobStatusModal() {
      this.selectedExportJob = null;
      this.$refs["modal-exportjob-status"].hide();
    },
    loadAuthuser(id) {
      let view = this;
      if (!view.authusers.hasOwnProperty(id)) {
        view.authusers[id] = {
          id: id,
          uuid: "",
          name: view.$t('settings.help.periodicStart'),
          mail: ""
        };
        let baseurl = '/api/sec/authuser';
        let url = baseurl;
        url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);
        url = this.$helpers.appendParam("id", id, url, baseurl);

        return this.axios({
          method: 'get',
          headers: {'AUTHORIZATION': "Bearer " + this.$store.state.jwt},
          url: url,
        }).then(response => {
          view.authusers[id] = response.data.data;
        }).catch(function (error) {
          console.log(error);
        })
      } else {
        return Promise.resolve();
      }
    },
    openInNewTab(url) {
      window.open(url, '_blank');
    },
    getEmployeeName(empId) {
      let view = this;
      let emp = view.employeeArray.find(emp => emp.id === empId);
      if (emp) {
        return emp.firstName + " " + emp.lastName;
      } else {
        return "";
      }
    },

    save: function (key) {
      let view = this;
      view.saves = true;

      let promises = [];

      promises.push(view.saveCompanyData()
      .then((response) => {
        view.bmdId = view.inputBmdId;
        view.dpwId = view.inputDpwId;
        view.companyNumber = view.inputCompanyNumber;

        for (let i = 0; i < view.storesData.length; i++) {
          view.storesData[i].bmdId = view.storesData[i].inputBmdId;
          view.storesData[i].dpwId = view.storesData[i].inputDpwId;
          view.storesData[i].costCenter = view.storesData[i].inputCostCenter;
          view.storesData[i].storeNumber = view.storesData[i].inputStoreNumber;
          view.storesData[i].municipalitySerialNumber = view.storesData[i].inputMunicipalitySerialNumber;
          view.storesData[i].allocationGroup = view.storesData[i].inputAllocationGroup;
          view.storesData[i].bankAccountOriginator = view.storesData[i].inputBankAccountOriginator;
        }
      }));
      promises.push(view.saveCollectiveContracts()
      .then((response) => {

        if (response !== undefined && response.data !== undefined && response.data.data !== undefined) {
          Object.values(response.data.data).forEach(respEntry => {
            let result = view.collectiveContractMappingArray.find(res => {
              return res.mdId === respEntry.mdId;
            });
            result.id = (respEntry.externalIdEmployee || respEntry.externalIdWorker) ? respEntry.id : null; // remove id from deleted entries (external id == null)
            result.externalIdEmployee = respEntry.externalIdEmployee;
            result.externalIdWorker = respEntry.externalIdWorker;
            result.externalIdEmployee_input = respEntry.externalIdEmployee;
            result.externalIdWorker_input = respEntry.externalIdWorker;
          });

          // view.$helpers.info(
          //   "Speichern erfolgreich",
          //   "Kollektivverträge wurde erfolgreich gespeichert"
          // );
        }
      }));
      promises.push(view.saveContractWeekModelNrs()
      .then((response) => {
        this.similarContractWeekModelNrArray = []; // set to different value to force a recalculation of similarAllowedContracts computed value
        Object.values(view.allowedContractArray).forEach(acperstore => {
          Object.values(acperstore).forEach(ac => {
            ac.externalId = ac.externalId_input;
          })
        });

        // view.$helpers.info(
        //   "Speichern erfolgreich",
        //   "Wochenmodelle wurden erfolgreich gespeichert"
        // );
      }));
      promises.push(view.saveEmployeeSyncSettingsData()
      .then((response) => {
        view.employeeSyncSettingsData_input.id = response.data.id;
        view.employeeSyncSettingsData = JSON.parse(JSON.stringify(view.employeeSyncSettingsData_input));
        // view.$helpers.info(
        //   "Speichern erfolgreich",
        //   "Mitarbeiter Sync Einstellungen wurde erfolgreich gespeichert"
        // );
        VueEventBus.$emit("EmployeeSyncSettingsEvent:updated", view.employeeSyncSettingsData);
      }));
      promises.push(view.saveEmployeeSyncExportProfiles()
      .then(response => {
        let oldProfileId = view.selectedProfileId;
        if (oldProfileId < 0) {
          view.selectedProfileId = view.exportProfiles.find(p => p.isDefault)?.id || -1;
        }
        view.exportProfiles = JSON.parse(JSON.stringify(response.data.data));
        view.exportProfiles_input = JSON.parse(JSON.stringify(response.data.data));
        view.selectedProfileId = oldProfileId < 0
          ? Math.max(...view.exportProfiles_input.map(p => p.id))
          : oldProfileId;
      }));
      promises.push(view.saveWageGroups()
      .then((response) => {
        view.wageGroup_input.id = response.data.id;
        view.wageGroup = view.wageGroup_input;
        // view.$helpers.info(
        //   "Speichern erfolgreich",
        //   "Tarifgruppen wurde erfolgreich gespeichert"
        // );
      }));
      promises.push(view.saveValuationModels()
      .then((response) => {
        view.valuationModel_input.id = response.data.id;
        view.valuationModel = view.valuationModel_input;
        // view.$helpers.info(
        //   "Speichern erfolgreich",
        //   "Bewertungsmodelle wurde erfolgreich gespeichert"
        // );
      }));
      promises.push(view.saveEmployeeSyncFieldSettings()
      .then((response) => {
        // view.$helpers.info(
        //   "Speichern erfolgreich",
        //   "SyncFelder wurden erfolgreich gespeichert"
        // );
      }));
      promises.push(view.savePeriodicExportTimes()
      .then(response => {
        view.periodicExportTimes = JSON.parse(JSON.stringify(response.data.data));
        view.periodicExportTimes_input = JSON.parse(JSON.stringify(response.data.data));
      }));

      Promise.all(promises)
      .then((resp) => {
        view.$helpers.success(
            view.$t('settings.ui.saveSuccessTitle'),
            view.$t('settings.ui.saveSuccessMessage')
        );
      })
      .catch(function (error) {
        console.log(error);
        // view.$helpers.error(
        //     "Speichern fehlgeschlagen",
        //     "Fehler beim Speichern der Daten"
        // );
      })
      .finally(() => {
        view.editieren = false;
        view.saves = false;
      });
    },
    saveCompanyData() {
      let view = this;
      let payload = {
        companyId: this.$store.state.companyId,
        bmdId: this.inputBmdId,
        dpwId: this.inputDpwId,
        companyNumber: this.inputCompanyNumber,
      };
      payload["stores"] = [];
      for (let i = 0; i < view.storesData.length; i++) {
        payload["stores"].push({
          storeId: view.storesData[i].id,
          bmdId: view.storesData[i].inputBmdId,
          dpwId: view.storesData[i].inputDpwId,
          costCenter: view.storesData[i].inputCostCenter,
          storeNumber: view.storesData[i].inputStoreNumber,
          municipalitySerialNumber: view.storesData[i].inputMunicipalitySerialNumber,
          allocationGroup: view.storesData[i].inputAllocationGroup,
          bankAccountOriginator: view.storesData[i].inputBankAccountOriginator,
        });
      }

      let url = "/api/company";

      return this.axios({
        method: "put",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        data: payload,
      });
    },
    setDeltaCalculationFlag: function(exportJob) {
      let view = this;
      let url = "/api/sec/employeesync/exports/setDeltaCalculationFlag";
      let payload = {
        exportJobId: exportJob.id,
        useForDeltaCalculation: exportJob.useForDeltaCalculation
      };
      return view.$helpers.EditCall(url, payload, null, null, null, null);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.parentBox {

}

.xColumn2 {
  width: 48%;
  text-align: left;
  float: left;
  margin-left: 1%;
  margin-right: 1%;
  overflow-y: auto;
  padding-bottom: 20px;
}

.xColumn2 > .header {
  display: inline-block;
  width: 100%;
  color: #e51550;
  font-size: 15px;
  font-weight: 700;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 7px;
}

.xColumn2 > .sub-header {
  display: inline-block;
  width: 90%;
  color: #e51550;
  font-size: 14px;
  font-weight: 400;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 10px 5px 5px;
}

.entryBox {
  font-size: 13px;
  text-align: left;
  padding: 12px 7px;
}

.entryBox .entryHeader {
  display: inline-block;
  width: 50%;
  float: left;
  color: #555;
  font-weight: 700;
}

.entryBox .entryHeaderLight {
  display: inline-block;
  width: 50%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox .entryData {
  display: inline-block;
  width: 50%;
  float: right;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox.triple .entryHeader.first {
  display: inline-block;
  width: 50%;
  float: left;
  color: #555;
  font-weight: 700;
}

.entryBox.triple .entryHeader {
  display: inline-block;
  width: 25%;
  float: left;
  color: #555;
  font-weight: 700;
}

.entryBox.triple .entryHeaderLight.first {
  display: inline-block;
  width: 50%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox.triple .entryHeaderLight {
  display: inline-block;
  width: 25%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox.triple .entryData.first {
  display: inline-block;
  width: 50%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox.triple .entryData {
  display: inline-block;
  width: 25%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.btn-ml {
  color: #fff;
  background-color: var(--ml);
  border-color: var(--ml);
}

.btn-ml:hover {
  color: #fff;
  background-color: #cc1347;
  border-color: #cc1347;
}

.table th {
  vertical-align: middle;
}

/* card */
.card {
  width: 90%;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(18,24,32,0.06);
  padding: 18px;
  overflow: visible;
  margin: 10px 0px 0px;
  display: block;
  background: var(--contrast-9);
}
/* tabs */
.tabs {
  display: flex;
  gap: 12px;
  align-items: center;
  border-bottom: 1px solid var(--contrast-7);
  /* padding-bottom: 12px; */
  /* margin-bottom: 14px; */
}
.tab {
  padding: 8px 6px;
  cursor: pointer;
  font-weight: 600;
  background: none;
  color: var(--contrast-7);
  /* font-size: 20px; */
  user-select: none;
  border: none;
}
.tab.active {
  position: relative;
  color: var(--ml);
}
.tab.active::after{
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--ml);
  bottom: -2px;
  border-radius: 3px;
}

</style>
